export const FROM_GLASGOW: {
  [name: string]: { meters: number; seconds: number }
} = {
  'https://www.walkhighlands.co.uk/angus/mayar-driesh.shtml': {
    meters: 184646,
    seconds: 8552,
  },
  'https://www.walkhighlands.co.uk/angus/mount-keen.shtml': {
    meters: 203155,
    seconds: 9050,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-achaladair.shtml': {
    meters: 115526,
    seconds: 5945,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-bhuidhe.shtml': {
    meters: 90657,
    seconds: 4679,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-dorain.shtml': {
    meters: 110789,
    seconds: 5698,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-eunaich.shtml': {
    meters: 123112,
    seconds: 6314,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-fhionnlaidh.shtml': {
    meters: 173287,
    seconds: 9288,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-mhanach.shtml': {
    meters: 103402,
    seconds: 5350,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-sgulaird.shtml': {
    meters: 168948,
    seconds: 8953,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-challum.shtml': {
    meters: 96612,
    seconds: 4987,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-cruachan.shtml': {
    meters: 128975,
    seconds: 6660,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-lui.shtml': {
    meters: 111099,
    seconds: 5698,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-oss.shtml': {
    meters: 98353,
    seconds: 5101,
  },
  'https://www.walkhighlands.co.uk/argyll/stob-ghabhar.shtml': {
    meters: 116364,
    seconds: 6170,
  },
  'https://www.walkhighlands.co.uk/cairngorms/a-mharconaich.shtml': {
    meters: 175803,
    seconds: 6955,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-sgarsoch.shtml': {
    meters: 184432,
    seconds: 9137,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-socach.shtml': {
    meters: 164833,
    seconds: 7862,
  },
  'https://www.walkhighlands.co.uk/cairngorms/aonach-beag.shtml': {
    meters: 197289,
    seconds: 9559,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-bhuird.shtml': {
    meters: 190251,
    seconds: 9665,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-chaorainn.shtml': {
    meters: 184390,
    seconds: 9133,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-bhrotain.shtml': {
    meters: 222557,
    seconds: 9456,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-iutharn-mhor.shtml': {
    meters: 181163,
    seconds: 8890,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-mheadhoin.shtml': {
    meters: 236781,
    seconds: 9828,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-udlamain.shtml': {
    meters: 171991,
    seconds: 6782,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-alder.shtml': {
    meters: 197289,
    seconds: 9559,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-avon.shtml': {
    meters: 178865,
    seconds: 8687,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-macdui.shtml': {
    meters: 184390,
    seconds: 9133,
  },
  'https://www.walkhighlands.co.uk/cairngorms/bynackmore.shtml': {
    meters: 231982,
    seconds: 9480,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairn-toul.shtml': {
    meters: 233353,
    seconds: 9540,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairnwell.shtml': {
    meters: 159350,
    seconds: 7587,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-a-mhaim.shtml': {
    meters: 184390,
    seconds: 9133,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-na-caim.shtml': {
    meters: 178736,
    seconds: 7058,
  },
  'https://www.walkhighlands.co.uk/cairngorms/geal-charn.shtml': {
    meters: 205404,
    seconds: 9028,
  },
  'https://www.walkhighlands.co.uk/cairngorms/glas-maol.shtml': {
    meters: 161457,
    seconds: 7697,
  },
  'https://www.walkhighlands.co.uk/cairngorms/macdui-cairngorm.shtml': {
    meters: 236781,
    seconds: 9828,
  },
  'https://www.walkhighlands.co.uk/cairngorms/meall-chuaich.shtml': {
    meters: 183805,
    seconds: 7265,
  },
  'https://www.walkhighlands.co.uk/cairngorms/monadhliath.shtml': {
    meters: 201148,
    seconds: 8380,
  },
  'https://www.walkhighlands.co.uk/cairngorms/mullach-clach-a-bhlair.shtml': {
    meters: 222557,
    seconds: 9456,
  },
  'https://www.walkhighlands.co.uk/cairngorms/sgor-gaoith.shtml': {
    meters: 219588,
    seconds: 9208,
  },
  'https://www.walkhighlands.co.uk/cairngorms/tolmount.shtml': {
    meters: 170396,
    seconds: 8194,
  },
  'https://www.walkhighlands.co.uk/cairngorms/white-mounth.shtml': {
    meters: 214193,
    seconds: 10814,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonacheagach.shtml': {
    meters: 140056,
    seconds: 7066,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonachmor.shtml': {
    meters: 186010,
    seconds: 10147,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-a-chlachair.shtml': {
    meters: 216310,
    seconds: 9069,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-na-lap.shtml': {
    meters: 240242,
    seconds: 11598,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-nan-aighenan.shtml': {
    meters: 148163,
    seconds: 8324,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnabheithir.shtml': {
    meters: 150713,
    seconds: 7647,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnachaorainn.shtml': {
    meters: 222252,
    seconds: 9354,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/benstarav.shtml': {
    meters: 148163,
    seconds: 8324,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/bideannambian.shtml': {
    meters: 140352,
    seconds: 7084,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/binneinmor.shtml': {
    meters: 160360,
    seconds: 8304,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivebeag.shtml': {
    meters: 138270,
    seconds: 6958,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivemor.shtml': {
    meters: 134748,
    seconds: 6786,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/carnmordeargarete.shtml': {
    meters: 181162,
    seconds: 9611,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/chnodearg.shtml': {
    meters: 230334,
    seconds: 9942,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creagmeagaidh.shtml': {
    meters: 209627,
    seconds: 8834,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creise.shtml': {
    meters: 130560,
    seconds: 6684,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/easains.shtml': {
    meters: 230344,
    seconds: 9943,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gairich.shtml': {
    meters: 240772,
    seconds: 12952,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/greycorries.shtml': {
    meters: 194672,
    seconds: 10583,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gulvain.shtml': {
    meters: 195170,
    seconds: 10136,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ladhar-bheinn.shtml': {
    meters: 242386,
    seconds: 12473,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/lochlochymunros.shtml': {
    meters: 214308,
    seconds: 11347,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/luinne-bheinn.shtml': {
    meters: 242386,
    seconds: 12473,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ringofsteall.shtml': {
    meters: 186008,
    seconds: 10147,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgor-gaibhre.shtml': {
    meters: 240242,
    seconds: 11598,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgornaulaidh.shtml': {
    meters: 145663,
    seconds: 7345,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurr-mor.shtml': {
    meters: 219019,
    seconds: 13299,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurramhaoraich.shtml': {
    meters: 247657,
    seconds: 13481,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurreildemor.shtml': {
    meters: 160380,
    seconds: 8307,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrnaciche.shtml': {
    meters: 219019,
    seconds: 13299,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrthuilm.shtml': {
    meters: 201404,
    seconds: 10440,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/spideanmialach.shtml': {
    meters: 245719,
    seconds: 13333,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stob-ban-grey-corries.shtml': {
    meters: 195252,
    seconds: 10723,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobban.shtml': {
    meters: 183253,
    seconds: 9734,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobcoiranalbannaich.shtml': {
    meters: 148163,
    seconds: 8324,
  },
  'https://www.walkhighlands.co.uk/kintail/Achralaig.shtml': {
    meters: 248708,
    seconds: 12754,
  },
  'https://www.walkhighlands.co.uk/kintail/Aghlasbheinn.shtml': {
    meters: 272177,
    seconds: 14021,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnfhada.shtml': {
    meters: 272177,
    seconds: 14021,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnsgritheall.shtml': {
    meters: 298999,
    seconds: 15991,
  },
  'https://www.walkhighlands.co.uk/kintail/Brothersridge.shtml': {
    meters: 257548,
    seconds: 13184,
  },
  'https://www.walkhighlands.co.uk/kintail/Cistedhubh.shtml': {
    meters: 248708,
    seconds: 12754,
  },
  'https://www.walkhighlands.co.uk/kintail/Fivesisters.shtml': {
    meters: 257531,
    seconds: 13183,
  },
  'https://www.walkhighlands.co.uk/kintail/Glenshielridge.shtml': {
    meters: 249650,
    seconds: 12807,
  },
  'https://www.walkhighlands.co.uk/kintail/sgurrnanconbhairean.shtml': {
    meters: 242060,
    seconds: 12481,
  },
  'https://www.walkhighlands.co.uk/kintail/Thesaddle.shtml': {
    meters: 262427,
    seconds: 13413,
  },
  'https://www.walkhighlands.co.uk/lochlomond/an-caisteal.shtml': {
    meters: 90276,
    seconds: 4718,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-chabhair.shtml': {
    meters: 82264,
    seconds: 4303,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-ime.shtml': {
    meters: 70017,
    seconds: 3546,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-lomond.shtml': {
    meters: 53249,
    seconds: 4187,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-more.shtml': {
    meters: 96887,
    seconds: 5056,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vane.shtml': {
    meters: 72772,
    seconds: 3758,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vorlich-lomond.shtml': {
    meters: 72772,
    seconds: 3758,
  },
  'https://www.walkhighlands.co.uk/lochlomond/cruach-ardrain.shtml': {
    meters: 96311,
    seconds: 5468,
  },
  'https://www.walkhighlands.co.uk/lochness/Benwyvis.shtml': {
    meters: 313913,
    seconds: 12708,
  },
  'https://www.walkhighlands.co.uk/lochness/carn-eige.shtml': {
    meters: 330631,
    seconds: 14638,
  },
  'https://www.walkhighlands.co.uk/lochness/Ceathreamhnan.shtml': {
    meters: 346855,
    seconds: 16077,
  },
  'https://www.walkhighlands.co.uk/lochness/mullardoch-munros.shtml': {
    meters: 330036,
    seconds: 14756,
  },
  'https://www.walkhighlands.co.uk/lochness/strathfarrar-munros.shtml': {
    meters: 320397,
    seconds: 13905,
  },
  'https://www.walkhighlands.co.uk/lochness/Tollcreagach.shtml': {
    meters: 330631,
    seconds: 14638,
  },
  'https://www.walkhighlands.co.uk/mull/ben-more-mull.shtml': {
    meters: 205287,
    seconds: 14548,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-a-ghlo.shtml': {
    meters: 148159,
    seconds: 6247,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-dearg.shtml': {
    meters: 145119,
    seconds: 5905,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-heasgarnich.shtml': {
    meters: 111714,
    seconds: 6212,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-chonzie.shtml': {
    meters: 86151,
    seconds: 4367,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-lawers.shtml': {
    meters: 110040,
    seconds: 5773,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-vorlich.shtml': {
    meters: 91579,
    seconds: 4707,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-a-chlamain.shtml': {
    meters: 145116,
    seconds: 5905,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-mairg.shtml': {
    meters: 131671,
    seconds: 7130,
  },
  'https://www.walkhighlands.co.uk/perthshire/glas-tulaichean.shtml': {
    meters: 150650,
    seconds: 7207,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-buidhe.shtml': {
    meters: 129012,
    seconds: 7449,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-corranaich.shtml': {
    meters: 114536,
    seconds: 6189,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-garbh.shtml': {
    meters: 113794,
    seconds: 5849,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-ghaordaidh.shtml': {
    meters: 106466,
    seconds: 5690,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-nan-tarmachan.shtml': {
    meters: 110022,
    seconds: 5771,
  },
  'https://www.walkhighlands.co.uk/perthshire/schiehallion.shtml': {
    meters: 130732,
    seconds: 6927,
  },
  'https://www.walkhighlands.co.uk/perthshire/sgiath-chuil.shtml': {
    meters: 111714,
    seconds: 6212,
  },
  'https://www.walkhighlands.co.uk/perthshire/stuchd-an-lochain.shtml': {
    meters: 129081,
    seconds: 7449,
  },
  'https://www.walkhighlands.co.uk/skye/ambasteir.shtml': {
    meters: 333696,
    seconds: 16985,
  },
  'https://www.walkhighlands.co.uk/skye/blabheinn.shtml': {
    meters: 319843,
    seconds: 16728,
  },
  'https://www.walkhighlands.co.uk/skye/bruachnafrithe.shtml': {
    meters: 334167,
    seconds: 17013,
  },
  'https://www.walkhighlands.co.uk/skye/innpinn.shtml': {
    meters: 356026,
    seconds: 18560,
  },
  'https://www.walkhighlands.co.uk/skye/sgurr-mhic-choinnich.shtml': {
    meters: 357211,
    seconds: 18769,
  },
  'https://www.walkhighlands.co.uk/skye/sgurraghreadaidh.shtml': {
    meters: 355109,
    seconds: 18487,
  },
  'https://www.walkhighlands.co.uk/skye/sgurralasdair.shtml': {
    meters: 357211,
    seconds: 18769,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnabanachdich.shtml': {
    meters: 355109,
    seconds: 18487,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnaneag.shtml': {
    meters: 357211,
    seconds: 18769,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnangillean.shtml': {
    meters: 333813,
    seconds: 17025,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-hope.shtml': {
    meters: 398949,
    seconds: 17850,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-klibreck.shtml': {
    meters: 368251,
    seconds: 15632,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnalligin.shtml': {
    meters: 368553,
    seconds: 15765,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinneighe.shtml': {
    meters: 357814,
    seconds: 14886,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnliathmhor.shtml': {
    meters: 352832,
    seconds: 14413,
  },
  'https://www.walkhighlands.co.uk/torridon/bideinachoiresheasgaich.shtml': {
    meters: 367704,
    seconds: 15305,
  },
  'https://www.walkhighlands.co.uk/torridon/Fionnbheinn.shtml': {
    meters: 332967,
    seconds: 13555,
  },
  'https://www.walkhighlands.co.uk/torridon/Liathach.shtml': {
    meters: 360213,
    seconds: 15062,
  },
  'https://www.walkhighlands.co.uk/torridon/maoilelunndaidh.shtml': {
    meters: 349191,
    seconds: 14267,
  },
  'https://www.walkhighlands.co.uk/torridon/Maolcheandearg.shtml': {
    meters: 358939,
    seconds: 14789,
  },
  'https://www.walkhighlands.co.uk/torridon/Moruisg.shtml': {
    meters: 344144,
    seconds: 13994,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgorrruadh.shtml': {
    meters: 352825,
    seconds: 14458,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgurrchoinnich.shtml': {
    meters: 349196,
    seconds: 14268,
  },
  'https://www.walkhighlands.co.uk/torridon/Slioch.shtml': {
    meters: 348024,
    seconds: 14264,
  },
  'https://www.walkhighlands.co.uk/ullapool/amfaochagach.shtml': {
    meters: 331006,
    seconds: 13448,
  },
  'https://www.walkhighlands.co.uk/ullapool/anteallach.shtml': {
    meters: 360544,
    seconds: 14828,
  },
  'https://www.walkhighlands.co.uk/ullapool/beinndearg.shtml': {
    meters: 347320,
    seconds: 14175,
  },
  'https://www.walkhighlands.co.uk/ullapool/benmoreassynt.shtml': {
    meters: 395674,
    seconds: 16649,
  },
  'https://www.walkhighlands.co.uk/ullapool/fannichs.shtml': {
    meters: 331006,
    seconds: 13448,
  },
  'https://www.walkhighlands.co.uk/ullapool/fisherfield-6.shtml': {
    meters: 356593,
    seconds: 14633,
  },
  'https://www.walkhighlands.co.uk/ullapool/seana-bhraigh.shtml': {
    meters: 347371,
    seconds: 14148,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrbreac.shtml': {
    meters: 345010,
    seconds: 14088,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrnanclachgeala.shtml': {
    meters: 345001,
    seconds: 14088,
  },
}

export const FROM_EDINBURGH: {
  [name: string]: { meters: number; seconds: number }
} = {
  'https://www.walkhighlands.co.uk/angus/mayar-driesh.shtml': {
    meters: 155136,
    seconds: 8037,
  },
  'https://www.walkhighlands.co.uk/angus/mount-keen.shtml': {
    meters: 173645,
    seconds: 8535,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-achaladair.shtml': {
    meters: 153132,
    seconds: 8159,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-bhuidhe.shtml': {
    meters: 164592,
    seconds: 8038,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-dorain.shtml': {
    meters: 148394,
    seconds: 7911,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-eunaich.shtml': {
    meters: 160718,
    seconds: 8528,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-fhionnlaidh.shtml': {
    meters: 210893,
    seconds: 11502,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-mhanach.shtml': {
    meters: 141007,
    seconds: 7564,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-sgulaird.shtml': {
    meters: 206554,
    seconds: 11167,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-challum.shtml': {
    meters: 134218,
    seconds: 7201,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-cruachan.shtml': {
    meters: 166581,
    seconds: 8874,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-lui.shtml': {
    meters: 148705,
    seconds: 7912,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-oss.shtml': {
    meters: 135958,
    seconds: 7315,
  },
  'https://www.walkhighlands.co.uk/argyll/stob-ghabhar.shtml': {
    meters: 153969,
    seconds: 8384,
  },
  'https://www.walkhighlands.co.uk/cairngorms/a-mharconaich.shtml': {
    meters: 155554,
    seconds: 6835,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-sgarsoch.shtml': {
    meters: 159702,
    seconds: 8911,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-socach.shtml': {
    meters: 140103,
    seconds: 7636,
  },
  'https://www.walkhighlands.co.uk/cairngorms/aonach-beag.shtml': {
    meters: 177040,
    seconds: 9439,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-bhuird.shtml': {
    meters: 165521,
    seconds: 9439,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-chaorainn.shtml': {
    meters: 159660,
    seconds: 8907,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-bhrotain.shtml': {
    meters: 202308,
    seconds: 9336,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-iutharn-mhor.shtml': {
    meters: 156433,
    seconds: 8664,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-mheadhoin.shtml': {
    meters: 216532,
    seconds: 9708,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-udlamain.shtml': {
    meters: 151742,
    seconds: 6662,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-alder.shtml': {
    meters: 177040,
    seconds: 9439,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-avon.shtml': {
    meters: 154135,
    seconds: 8461,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-macdui.shtml': {
    meters: 159660,
    seconds: 8907,
  },
  'https://www.walkhighlands.co.uk/cairngorms/bynackmore.shtml': {
    meters: 211733,
    seconds: 9360,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairn-toul.shtml': {
    meters: 213104,
    seconds: 9420,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairnwell.shtml': {
    meters: 134620,
    seconds: 7361,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-a-mhaim.shtml': {
    meters: 159660,
    seconds: 8907,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-na-caim.shtml': {
    meters: 158487,
    seconds: 6938,
  },
  'https://www.walkhighlands.co.uk/cairngorms/geal-charn.shtml': {
    meters: 185155,
    seconds: 8908,
  },
  'https://www.walkhighlands.co.uk/cairngorms/glas-maol.shtml': {
    meters: 136727,
    seconds: 7471,
  },
  'https://www.walkhighlands.co.uk/cairngorms/macdui-cairngorm.shtml': {
    meters: 216532,
    seconds: 9708,
  },
  'https://www.walkhighlands.co.uk/cairngorms/meall-chuaich.shtml': {
    meters: 163556,
    seconds: 7145,
  },
  'https://www.walkhighlands.co.uk/cairngorms/monadhliath.shtml': {
    meters: 180899,
    seconds: 8260,
  },
  'https://www.walkhighlands.co.uk/cairngorms/mullach-clach-a-bhlair.shtml': {
    meters: 202308,
    seconds: 9336,
  },
  'https://www.walkhighlands.co.uk/cairngorms/sgor-gaoith.shtml': {
    meters: 199339,
    seconds: 9088,
  },
  'https://www.walkhighlands.co.uk/cairngorms/tolmount.shtml': {
    meters: 145666,
    seconds: 7968,
  },
  'https://www.walkhighlands.co.uk/cairngorms/white-mounth.shtml': {
    meters: 189463,
    seconds: 10588,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonacheagach.shtml': {
    meters: 177661,
    seconds: 9280,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonachmor.shtml': {
    meters: 242937,
    seconds: 11907,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-a-chlachair.shtml': {
    meters: 196061,
    seconds: 8949,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-na-lap.shtml': {
    meters: 219993,
    seconds: 11478,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-nan-aighenan.shtml': {
    meters: 185768,
    seconds: 10538,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnabheithir.shtml': {
    meters: 188318,
    seconds: 9861,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnachaorainn.shtml': {
    meters: 202003,
    seconds: 9234,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/benstarav.shtml': {
    meters: 185768,
    seconds: 10538,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/bideannambian.shtml': {
    meters: 177957,
    seconds: 9297,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/binneinmor.shtml': {
    meters: 197965,
    seconds: 10518,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivebeag.shtml': {
    meters: 175876,
    seconds: 9172,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivemor.shtml': {
    meters: 172353,
    seconds: 9000,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/carnmordeargarete.shtml': {
    meters: 229145,
    seconds: 10744,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/chnodearg.shtml': {
    meters: 210085,
    seconds: 9822,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creagmeagaidh.shtml': {
    meters: 189378,
    seconds: 8714,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creise.shtml': {
    meters: 168165,
    seconds: 8898,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/easains.shtml': {
    meters: 210095,
    seconds: 9823,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gairich.shtml': {
    meters: 270082,
    seconds: 13187,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/greycorries.shtml': {
    meters: 224359,
    seconds: 10851,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gulvain.shtml': {
    meters: 248304,
    seconds: 11569,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ladhar-bheinn.shtml': {
    meters: 295520,
    seconds: 13906,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/lochlochymunros.shtml': {
    meters: 243618,
    seconds: 11581,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/luinne-bheinn.shtml': {
    meters: 295520,
    seconds: 13906,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ringofsteall.shtml': {
    meters: 242935,
    seconds: 11907,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgor-gaibhre.shtml': {
    meters: 219993,
    seconds: 11478,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgornaulaidh.shtml': {
    meters: 183268,
    seconds: 9559,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurr-mor.shtml': {
    meters: 253684,
    seconds: 13581,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurramhaoraich.shtml': {
    meters: 276967,
    seconds: 13716,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurreildemor.shtml': {
    meters: 197985,
    seconds: 10521,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrnaciche.shtml': {
    meters: 253684,
    seconds: 13581,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrthuilm.shtml': {
    meters: 254538,
    seconds: 11873,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/spideanmialach.shtml': {
    meters: 275029,
    seconds: 13568,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stob-ban-grey-corries.shtml': {
    meters: 224939,
    seconds: 10991,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobban.shtml': {
    meters: 240180,
    seconds: 11494,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobcoiranalbannaich.shtml': {
    meters: 185768,
    seconds: 10538,
  },
  'https://www.walkhighlands.co.uk/kintail/Achralaig.shtml': {
    meters: 278018,
    seconds: 12989,
  },
  'https://www.walkhighlands.co.uk/kintail/Aghlasbheinn.shtml': {
    meters: 301487,
    seconds: 14256,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnfhada.shtml': {
    meters: 301487,
    seconds: 14256,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnsgritheall.shtml': {
    meters: 328309,
    seconds: 16226,
  },
  'https://www.walkhighlands.co.uk/kintail/Brothersridge.shtml': {
    meters: 286858,
    seconds: 13419,
  },
  'https://www.walkhighlands.co.uk/kintail/Cistedhubh.shtml': {
    meters: 278018,
    seconds: 12989,
  },
  'https://www.walkhighlands.co.uk/kintail/Fivesisters.shtml': {
    meters: 286841,
    seconds: 13418,
  },
  'https://www.walkhighlands.co.uk/kintail/Glenshielridge.shtml': {
    meters: 278960,
    seconds: 13042,
  },
  'https://www.walkhighlands.co.uk/kintail/sgurrnanconbhairean.shtml': {
    meters: 271370,
    seconds: 12716,
  },
  'https://www.walkhighlands.co.uk/kintail/Thesaddle.shtml': {
    meters: 291737,
    seconds: 13648,
  },
  'https://www.walkhighlands.co.uk/lochlomond/an-caisteal.shtml': {
    meters: 132522,
    seconds: 7161,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-chabhair.shtml': {
    meters: 140513,
    seconds: 7477,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-ime.shtml': {
    meters: 143952,
    seconds: 6905,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-lomond.shtml': {
    meters: 112920,
    seconds: 6383,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-more.shtml': {
    meters: 126000,
    seconds: 6797,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vane.shtml': {
    meters: 146707,
    seconds: 7117,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vorlich-lomond.shtml': {
    meters: 146707,
    seconds: 7117,
  },
  'https://www.walkhighlands.co.uk/lochlomond/cruach-ardrain.shtml': {
    meters: 112672,
    seconds: 6845,
  },
  'https://www.walkhighlands.co.uk/lochness/Benwyvis.shtml': {
    meters: 293664,
    seconds: 12588,
  },
  'https://www.walkhighlands.co.uk/lochness/carn-eige.shtml': {
    meters: 310382,
    seconds: 14518,
  },
  'https://www.walkhighlands.co.uk/lochness/Ceathreamhnan.shtml': {
    meters: 326606,
    seconds: 15957,
  },
  'https://www.walkhighlands.co.uk/lochness/mullardoch-munros.shtml': {
    meters: 309787,
    seconds: 14636,
  },
  'https://www.walkhighlands.co.uk/lochness/strathfarrar-munros.shtml': {
    meters: 300148,
    seconds: 13785,
  },
  'https://www.walkhighlands.co.uk/lochness/Tollcreagach.shtml': {
    meters: 310382,
    seconds: 14518,
  },
  'https://www.walkhighlands.co.uk/mull/ben-more-mull.shtml': {
    meters: 242893,
    seconds: 16762,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-a-ghlo.shtml': {
    meters: 127910,
    seconds: 6127,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-dearg.shtml': {
    meters: 124870,
    seconds: 5785,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-heasgarnich.shtml': {
    meters: 128075,
    seconds: 7589,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-chonzie.shtml': {
    meters: 102512,
    seconds: 5743,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-lawers.shtml': {
    meters: 126401,
    seconds: 7150,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-vorlich.shtml': {
    meters: 107940,
    seconds: 6084,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-a-chlamain.shtml': {
    meters: 124867,
    seconds: 5785,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-mairg.shtml': {
    meters: 141290,
    seconds: 7413,
  },
  'https://www.walkhighlands.co.uk/perthshire/glas-tulaichean.shtml': {
    meters: 125920,
    seconds: 6981,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-buidhe.shtml': {
    meters: 158364,
    seconds: 8659,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-corranaich.shtml': {
    meters: 130897,
    seconds: 7566,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-garbh.shtml': {
    meters: 141499,
    seconds: 7164,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-ghaordaidh.shtml': {
    meters: 122827,
    seconds: 7067,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-nan-tarmachan.shtml': {
    meters: 126383,
    seconds: 7148,
  },
  'https://www.walkhighlands.co.uk/perthshire/schiehallion.shtml': {
    meters: 137440,
    seconds: 7076,
  },
  'https://www.walkhighlands.co.uk/perthshire/sgiath-chuil.shtml': {
    meters: 128075,
    seconds: 7589,
  },
  'https://www.walkhighlands.co.uk/perthshire/stuchd-an-lochain.shtml': {
    meters: 158433,
    seconds: 8659,
  },
  'https://www.walkhighlands.co.uk/skye/ambasteir.shtml': {
    meters: 363006,
    seconds: 17220,
  },
  'https://www.walkhighlands.co.uk/skye/blabheinn.shtml': {
    meters: 349153,
    seconds: 16963,
  },
  'https://www.walkhighlands.co.uk/skye/bruachnafrithe.shtml': {
    meters: 363477,
    seconds: 17248,
  },
  'https://www.walkhighlands.co.uk/skye/innpinn.shtml': {
    meters: 385336,
    seconds: 18795,
  },
  'https://www.walkhighlands.co.uk/skye/sgurr-mhic-choinnich.shtml': {
    meters: 386521,
    seconds: 19004,
  },
  'https://www.walkhighlands.co.uk/skye/sgurraghreadaidh.shtml': {
    meters: 384419,
    seconds: 18722,
  },
  'https://www.walkhighlands.co.uk/skye/sgurralasdair.shtml': {
    meters: 386521,
    seconds: 19004,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnabanachdich.shtml': {
    meters: 384419,
    seconds: 18722,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnaneag.shtml': {
    meters: 386521,
    seconds: 19004,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnangillean.shtml': {
    meters: 363123,
    seconds: 17260,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-hope.shtml': {
    meters: 378700,
    seconds: 17730,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-klibreck.shtml': {
    meters: 348002,
    seconds: 15512,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnalligin.shtml': {
    meters: 348304,
    seconds: 15645,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinneighe.shtml': {
    meters: 337565,
    seconds: 14766,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnliathmhor.shtml': {
    meters: 332583,
    seconds: 14293,
  },
  'https://www.walkhighlands.co.uk/torridon/bideinachoiresheasgaich.shtml': {
    meters: 347455,
    seconds: 15185,
  },
  'https://www.walkhighlands.co.uk/torridon/Fionnbheinn.shtml': {
    meters: 312718,
    seconds: 13435,
  },
  'https://www.walkhighlands.co.uk/torridon/Liathach.shtml': {
    meters: 339964,
    seconds: 14942,
  },
  'https://www.walkhighlands.co.uk/torridon/maoilelunndaidh.shtml': {
    meters: 328942,
    seconds: 14147,
  },
  'https://www.walkhighlands.co.uk/torridon/Maolcheandearg.shtml': {
    meters: 338690,
    seconds: 14669,
  },
  'https://www.walkhighlands.co.uk/torridon/Moruisg.shtml': {
    meters: 323895,
    seconds: 13874,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgorrruadh.shtml': {
    meters: 332576,
    seconds: 14338,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgurrchoinnich.shtml': {
    meters: 328947,
    seconds: 14148,
  },
  'https://www.walkhighlands.co.uk/torridon/Slioch.shtml': {
    meters: 327775,
    seconds: 14144,
  },
  'https://www.walkhighlands.co.uk/ullapool/amfaochagach.shtml': {
    meters: 310757,
    seconds: 13328,
  },
  'https://www.walkhighlands.co.uk/ullapool/anteallach.shtml': {
    meters: 340295,
    seconds: 14708,
  },
  'https://www.walkhighlands.co.uk/ullapool/beinndearg.shtml': {
    meters: 327071,
    seconds: 14055,
  },
  'https://www.walkhighlands.co.uk/ullapool/benmoreassynt.shtml': {
    meters: 375425,
    seconds: 16529,
  },
  'https://www.walkhighlands.co.uk/ullapool/fannichs.shtml': {
    meters: 310757,
    seconds: 13328,
  },
  'https://www.walkhighlands.co.uk/ullapool/fisherfield-6.shtml': {
    meters: 336344,
    seconds: 14513,
  },
  'https://www.walkhighlands.co.uk/ullapool/seana-bhraigh.shtml': {
    meters: 327122,
    seconds: 14028,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrbreac.shtml': {
    meters: 324761,
    seconds: 13968,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrnanclachgeala.shtml': {
    meters: 324752,
    seconds: 13968,
  },
}

export const FROM_FORT_WILLIAM: {
  [name: string]: { meters: number; seconds: number }
} = {
  'https://www.walkhighlands.co.uk/angus/mayar-driesh.shtml': {
    meters: 209011,
    seconds: 11450,
  },
  'https://www.walkhighlands.co.uk/angus/mount-keen.shtml': {
    meters: 245834,
    seconds: 12458,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-achaladair.shtml': {
    meters: 59983,
    seconds: 3159,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-bhuidhe.shtml': {
    meters: 131792,
    seconds: 6684,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-dorain.shtml': {
    meters: 64298,
    seconds: 3312,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-eunaich.shtml': {
    meters: 96886,
    seconds: 4916,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-fhionnlaidh.shtml': {
    meters: 55876,
    seconds: 3271,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-mhanach.shtml': {
    meters: 71685,
    seconds: 3674,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-sgulaird.shtml': {
    meters: 52722,
    seconds: 3006,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-challum.shtml': {
    meters: 78475,
    seconds: 4020,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-cruachan.shtml': {
    meters: 84653,
    seconds: 4662,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-lui.shtml': {
    meters: 84873,
    seconds: 4300,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-oss.shtml': {
    meters: 76970,
    seconds: 4011,
  },
  'https://www.walkhighlands.co.uk/argyll/stob-ghabhar.shtml': {
    meters: 69657,
    seconds: 3799,
  },
  'https://www.walkhighlands.co.uk/cairngorms/a-mharconaich.shtml': {
    meters: 77575,
    seconds: 4106,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-sgarsoch.shtml': {
    meters: 194202,
    seconds: 10456,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-socach.shtml': {
    meters: 174604,
    seconds: 9181,
  },
  'https://www.walkhighlands.co.uk/cairngorms/aonach-beag.shtml': {
    meters: 66701,
    seconds: 5065,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-bhuird.shtml': {
    meters: 200021,
    seconds: 10984,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-chaorainn.shtml': {
    meters: 194160,
    seconds: 10452,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-bhrotain.shtml': {
    meters: 97062,
    seconds: 5568,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-iutharn-mhor.shtml': {
    meters: 190933,
    seconds: 10209,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-mheadhoin.shtml': {
    meters: 112189,
    seconds: 5957,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-udlamain.shtml': {
    meters: 81258,
    seconds: 4209,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-alder.shtml': {
    meters: 66701,
    seconds: 5065,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-avon.shtml': {
    meters: 188635,
    seconds: 10007,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-macdui.shtml': {
    meters: 194160,
    seconds: 10452,
  },
  'https://www.walkhighlands.co.uk/cairngorms/bynackmore.shtml': {
    meters: 107390,
    seconds: 5609,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairn-toul.shtml': {
    meters: 108761,
    seconds: 5669,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairnwell.shtml': {
    meters: 169120,
    seconds: 8907,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-a-mhaim.shtml': {
    meters: 194160,
    seconds: 10452,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-na-caim.shtml': {
    meters: 74516,
    seconds: 3924,
  },
  'https://www.walkhighlands.co.uk/cairngorms/geal-charn.shtml': {
    meters: 57883,
    seconds: 3343,
  },
  'https://www.walkhighlands.co.uk/cairngorms/glas-maol.shtml': {
    meters: 171227,
    seconds: 9016,
  },
  'https://www.walkhighlands.co.uk/cairngorms/macdui-cairngorm.shtml': {
    meters: 112189,
    seconds: 5957,
  },
  'https://www.walkhighlands.co.uk/cairngorms/meall-chuaich.shtml': {
    meters: 77733,
    seconds: 4046,
  },
  'https://www.walkhighlands.co.uk/cairngorms/monadhliath.shtml': {
    meters: 74586,
    seconds: 4143,
  },
  'https://www.walkhighlands.co.uk/cairngorms/mullach-clach-a-bhlair.shtml': {
    meters: 97062,
    seconds: 5568,
  },
  'https://www.walkhighlands.co.uk/cairngorms/sgor-gaoith.shtml': {
    meters: 94093,
    seconds: 5320,
  },
  'https://www.walkhighlands.co.uk/cairngorms/tolmount.shtml': {
    meters: 180166,
    seconds: 9513,
  },
  'https://www.walkhighlands.co.uk/cairngorms/white-mounth.shtml': {
    meters: 194465,
    seconds: 10578,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonacheagach.shtml': {
    meters: 35032,
    seconds: 1953,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonachmor.shtml': {
    meters: 10899,
    seconds: 1123,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-a-chlachair.shtml': {
    meters: 36921,
    seconds: 1914,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-na-lap.shtml': {
    meters: 60723,
    seconds: 4456,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-nan-aighenan.shtml': {
    meters: 59616,
    seconds: 4044,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnabheithir.shtml': {
    meters: 24776,
    seconds: 1497,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnachaorainn.shtml': {
    meters: 31009,
    seconds: 1670,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/benstarav.shtml': {
    meters: 59616,
    seconds: 4044,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/bideannambian.shtml': {
    meters: 34735,
    seconds: 1936,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/binneinmor.shtml': {
    meters: 34736,
    seconds: 2106,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivebeag.shtml': {
    meters: 36817,
    seconds: 2064,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivemor.shtml': {
    meters: 40339,
    seconds: 2236,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/carnmordeargarete.shtml': {
    meters: 6051,
    seconds: 587,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/chnodearg.shtml': {
    meters: 31019,
    seconds: 1878,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creagmeagaidh.shtml': {
    meters: 43756,
    seconds: 2218,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creise.shtml': {
    meters: 47004,
    seconds: 2641,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/easains.shtml': {
    meters: 31029,
    seconds: 1879,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gairich.shtml': {
    meters: 65661,
    seconds: 3928,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/greycorries.shtml': {
    meters: 19561,
    seconds: 1559,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gulvain.shtml': {
    meters: 20059,
    seconds: 1112,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ladhar-bheinn.shtml': {
    meters: 67275,
    seconds: 3449,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/lochlochymunros.shtml': {
    meters: 39197,
    seconds: 2323,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/luinne-bheinn.shtml': {
    meters: 67275,
    seconds: 3449,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ringofsteall.shtml': {
    meters: 10897,
    seconds: 1123,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgor-gaibhre.shtml': {
    meters: 60723,
    seconds: 4456,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgornaulaidh.shtml': {
    meters: 29424,
    seconds: 1671,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurr-mor.shtml': {
    meters: 43908,
    seconds: 4275,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurramhaoraich.shtml': {
    meters: 72546,
    seconds: 4457,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurreildemor.shtml': {
    meters: 34755,
    seconds: 2109,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrnaciche.shtml': {
    meters: 43908,
    seconds: 4275,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrthuilm.shtml': {
    meters: 26293,
    seconds: 1416,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/spideanmialach.shtml': {
    meters: 70608,
    seconds: 4309,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stob-ban-grey-corries.shtml': {
    meters: 20141,
    seconds: 1699,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobban.shtml': {
    meters: 8142,
    seconds: 710,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobcoiranalbannaich.shtml': {
    meters: 59616,
    seconds: 4044,
  },
  'https://www.walkhighlands.co.uk/kintail/Achralaig.shtml': {
    meters: 73597,
    seconds: 3730,
  },
  'https://www.walkhighlands.co.uk/kintail/Aghlasbheinn.shtml': {
    meters: 97066,
    seconds: 4997,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnfhada.shtml': {
    meters: 97066,
    seconds: 4997,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnsgritheall.shtml': {
    meters: 123888,
    seconds: 6967,
  },
  'https://www.walkhighlands.co.uk/kintail/Brothersridge.shtml': {
    meters: 82437,
    seconds: 4160,
  },
  'https://www.walkhighlands.co.uk/kintail/Cistedhubh.shtml': {
    meters: 73597,
    seconds: 3730,
  },
  'https://www.walkhighlands.co.uk/kintail/Fivesisters.shtml': {
    meters: 82420,
    seconds: 4159,
  },
  'https://www.walkhighlands.co.uk/kintail/Glenshielridge.shtml': {
    meters: 74539,
    seconds: 3783,
  },
  'https://www.walkhighlands.co.uk/kintail/sgurrnanconbhairean.shtml': {
    meters: 66949,
    seconds: 3457,
  },
  'https://www.walkhighlands.co.uk/kintail/Thesaddle.shtml': {
    meters: 87316,
    seconds: 4389,
  },
  'https://www.walkhighlands.co.uk/lochlomond/an-caisteal.shtml': {
    meters: 84790,
    seconds: 4360,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-chabhair.shtml': {
    meters: 92782,
    seconds: 4676,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-ime.shtml': {
    meters: 112554,
    seconds: 5971,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-lomond.shtml': {
    meters: 165393,
    seconds: 9115,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-more.shtml': {
    meters: 86651,
    seconds: 4450,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vane.shtml': {
    meters: 102460,
    seconds: 5320,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vorlich-lomond.shtml': {
    meters: 102460,
    seconds: 5320,
  },
  'https://www.walkhighlands.co.uk/lochlomond/cruach-ardrain.shtml': {
    meters: 125864,
    seconds: 7157,
  },
  'https://www.walkhighlands.co.uk/lochness/Benwyvis.shtml': {
    meters: 133433,
    seconds: 7259,
  },
  'https://www.walkhighlands.co.uk/lochness/carn-eige.shtml': {
    meters: 115981,
    seconds: 6769,
  },
  'https://www.walkhighlands.co.uk/lochness/Ceathreamhnan.shtml': {
    meters: 132205,
    seconds: 8208,
  },
  'https://www.walkhighlands.co.uk/lochness/mullardoch-munros.shtml': {
    meters: 115386,
    seconds: 6888,
  },
  'https://www.walkhighlands.co.uk/lochness/strathfarrar-munros.shtml': {
    meters: 125367,
    seconds: 7397,
  },
  'https://www.walkhighlands.co.uk/lochness/Tollcreagach.shtml': {
    meters: 115981,
    seconds: 6769,
  },
  'https://www.walkhighlands.co.uk/mull/ben-more-mull.shtml': {
    meters: 92302,
    seconds: 8840,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-a-ghlo.shtml': {
    meters: 113880,
    seconds: 5943,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-dearg.shtml': {
    meters: 110840,
    seconds: 5601,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-heasgarnich.shtml': {
    meters: 116182,
    seconds: 6530,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-chonzie.shtml': {
    meters: 134987,
    seconds: 7305,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-lawers.shtml': {
    meters: 114508,
    seconds: 6091,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-vorlich.shtml': {
    meters: 114212,
    seconds: 6068,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-a-chlamain.shtml': {
    meters: 110837,
    seconds: 5601,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-mairg.shtml': {
    meters: 136139,
    seconds: 7448,
  },
  'https://www.walkhighlands.co.uk/perthshire/glas-tulaichean.shtml': {
    meters: 160420,
    seconds: 8527,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-buidhe.shtml': {
    meters: 133480,
    seconds: 7767,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-corranaich.shtml': {
    meters: 119004,
    seconds: 6507,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-garbh.shtml': {
    meters: 118262,
    seconds: 6167,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-ghaordaidh.shtml': {
    meters: 110934,
    seconds: 6008,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-nan-tarmachan.shtml': {
    meters: 114490,
    seconds: 6089,
  },
  'https://www.walkhighlands.co.uk/perthshire/schiehallion.shtml': {
    meters: 118801,
    seconds: 6636,
  },
  'https://www.walkhighlands.co.uk/perthshire/sgiath-chuil.shtml': {
    meters: 116182,
    seconds: 6530,
  },
  'https://www.walkhighlands.co.uk/perthshire/stuchd-an-lochain.shtml': {
    meters: 133549,
    seconds: 7767,
  },
  'https://www.walkhighlands.co.uk/skye/ambasteir.shtml': {
    meters: 158585,
    seconds: 7961,
  },
  'https://www.walkhighlands.co.uk/skye/blabheinn.shtml': {
    meters: 144732,
    seconds: 7704,
  },
  'https://www.walkhighlands.co.uk/skye/bruachnafrithe.shtml': {
    meters: 159056,
    seconds: 7989,
  },
  'https://www.walkhighlands.co.uk/skye/innpinn.shtml': {
    meters: 180915,
    seconds: 9536,
  },
  'https://www.walkhighlands.co.uk/skye/sgurr-mhic-choinnich.shtml': {
    meters: 182100,
    seconds: 9745,
  },
  'https://www.walkhighlands.co.uk/skye/sgurraghreadaidh.shtml': {
    meters: 179998,
    seconds: 9463,
  },
  'https://www.walkhighlands.co.uk/skye/sgurralasdair.shtml': {
    meters: 182100,
    seconds: 9745,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnabanachdich.shtml': {
    meters: 179998,
    seconds: 9463,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnaneag.shtml': {
    meters: 182100,
    seconds: 9745,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnangillean.shtml': {
    meters: 158702,
    seconds: 8001,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-hope.shtml': {
    meters: 230039,
    seconds: 12851,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-klibreck.shtml': {
    meters: 199341,
    seconds: 10633,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnalligin.shtml': {
    meters: 177478,
    seconds: 9706,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinneighe.shtml': {
    meters: 186532,
    seconds: 9507,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnliathmhor.shtml': {
    meters: 142102,
    seconds: 7281,
  },
  'https://www.walkhighlands.co.uk/torridon/bideinachoiresheasgaich.shtml': {
    meters: 127293,
    seconds: 6435,
  },
  'https://www.walkhighlands.co.uk/torridon/Fionnbheinn.shtml': {
    meters: 162243,
    seconds: 8252,
  },
  'https://www.walkhighlands.co.uk/torridon/Liathach.shtml': {
    meters: 176215,
    seconds: 9496,
  },
  'https://www.walkhighlands.co.uk/torridon/maoilelunndaidh.shtml': {
    meters: 145889,
    seconds: 7503,
  },
  'https://www.walkhighlands.co.uk/torridon/Maolcheandearg.shtml': {
    meters: 135995,
    seconds: 6891,
  },
  'https://www.walkhighlands.co.uk/torridon/Moruisg.shtml': {
    meters: 150790,
    seconds: 7707,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgorrruadh.shtml': {
    meters: 142145,
    seconds: 7292,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgurrchoinnich.shtml': {
    meters: 145894,
    seconds: 7503,
  },
  'https://www.walkhighlands.co.uk/torridon/Slioch.shtml': {
    meters: 176741,
    seconds: 8885,
  },
  'https://www.walkhighlands.co.uk/ullapool/amfaochagach.shtml': {
    meters: 150526,
    seconds: 7999,
  },
  'https://www.walkhighlands.co.uk/ullapool/anteallach.shtml': {
    meters: 180064,
    seconds: 9379,
  },
  'https://www.walkhighlands.co.uk/ullapool/beinndearg.shtml': {
    meters: 166840,
    seconds: 8726,
  },
  'https://www.walkhighlands.co.uk/ullapool/benmoreassynt.shtml': {
    meters: 215195,
    seconds: 11200,
  },
  'https://www.walkhighlands.co.uk/ullapool/fannichs.shtml': {
    meters: 150526,
    seconds: 7999,
  },
  'https://www.walkhighlands.co.uk/ullapool/fisherfield-6.shtml': {
    meters: 176113,
    seconds: 9184,
  },
  'https://www.walkhighlands.co.uk/ullapool/seana-bhraigh.shtml': {
    meters: 166892,
    seconds: 8699,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrbreac.shtml': {
    meters: 164530,
    seconds: 8639,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrnanclachgeala.shtml': {
    meters: 164521,
    seconds: 8639,
  },
}

export const FROM_ABERDEEN: {
  [name: string]: { meters: number; seconds: number }
} = {
  'https://www.walkhighlands.co.uk/angus/mayar-driesh.shtml': {
    meters: 107954,
    seconds: 5565,
  },
  'https://www.walkhighlands.co.uk/angus/mount-keen.shtml': {
    meters: 84821,
    seconds: 4287,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-achaladair.shtml': {
    meters: 246872,
    seconds: 11733,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-bhuidhe.shtml': {
    meters: 283318,
    seconds: 12870,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-dorain.shtml': {
    meters: 242134,
    seconds: 11486,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-eunaich.shtml': {
    meters: 254458,
    seconds: 12102,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-fhionnlaidh.shtml': {
    meters: 304633,
    seconds: 15069,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-mhanach.shtml': {
    meters: 234747,
    seconds: 11140,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-sgulaird.shtml': {
    meters: 300294,
    seconds: 14742,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-challum.shtml': {
    meters: 227958,
    seconds: 10777,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-cruachan.shtml': {
    meters: 260321,
    seconds: 12448,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-lui.shtml': {
    meters: 242445,
    seconds: 11489,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-oss.shtml': {
    meters: 229698,
    seconds: 10890,
  },
  'https://www.walkhighlands.co.uk/argyll/stob-ghabhar.shtml': {
    meters: 247709,
    seconds: 11957,
  },
  'https://www.walkhighlands.co.uk/cairngorms/a-mharconaich.shtml': {
    meters: 197547,
    seconds: 8893,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-sgarsoch.shtml': {
    meters: 100375,
    seconds: 5997,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-socach.shtml': {
    meters: 98797,
    seconds: 5686,
  },
  'https://www.walkhighlands.co.uk/cairngorms/aonach-beag.shtml': {
    meters: 219033,
    seconds: 11628,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-bhuird.shtml': {
    meters: 106194,
    seconds: 6530,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-chaorainn.shtml': {
    meters: 100333,
    seconds: 5993,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-bhrotain.shtml': {
    meters: 169928,
    seconds: 9311,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-iutharn-mhor.shtml': {
    meters: 97106,
    seconds: 5752,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-mheadhoin.shtml': {
    meters: 145082,
    seconds: 9149,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-udlamain.shtml': {
    meters: 193735,
    seconds: 8721,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-alder.shtml': {
    meters: 219033,
    seconds: 11628,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-avon.shtml': {
    meters: 85318,
    seconds: 4974,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-macdui.shtml': {
    meters: 100333,
    seconds: 5993,
  },
  'https://www.walkhighlands.co.uk/cairngorms/bynackmore.shtml': {
    meters: 140196,
    seconds: 8768,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairn-toul.shtml': {
    meters: 141567,
    seconds: 8828,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairnwell.shtml': {
    meters: 104281,
    seconds: 5972,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-a-mhaim.shtml': {
    meters: 100333,
    seconds: 5993,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-na-caim.shtml': {
    meters: 200480,
    seconds: 8997,
  },
  'https://www.walkhighlands.co.uk/cairngorms/geal-charn.shtml': {
    meters: 197199,
    seconds: 10762,
  },
  'https://www.walkhighlands.co.uk/cairngorms/glas-maol.shtml': {
    meters: 102174,
    seconds: 5857,
  },
  'https://www.walkhighlands.co.uk/cairngorms/macdui-cairngorm.shtml': {
    meters: 145082,
    seconds: 9149,
  },
  'https://www.walkhighlands.co.uk/cairngorms/meall-chuaich.shtml': {
    meters: 205549,
    seconds: 9204,
  },
  'https://www.walkhighlands.co.uk/cairngorms/monadhliath.shtml': {
    meters: 176196,
    seconds: 9379,
  },
  'https://www.walkhighlands.co.uk/cairngorms/mullach-clach-a-bhlair.shtml': {
    meters: 169928,
    seconds: 9311,
  },
  'https://www.walkhighlands.co.uk/cairngorms/sgor-gaoith.shtml': {
    meters: 166959,
    seconds: 9062,
  },
  'https://www.walkhighlands.co.uk/cairngorms/tolmount.shtml': {
    meters: 93247,
    seconds: 5410,
  },
  'https://www.walkhighlands.co.uk/cairngorms/white-mounth.shtml': {
    meters: 78123,
    seconds: 4940,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonacheagach.shtml': {
    meters: 271401,
    seconds: 12850,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonachmor.shtml': {
    meters: 256292,
    seconds: 13835,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-a-chlachair.shtml': {
    meters: 209416,
    seconds: 10884,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-na-lap.shtml': {
    meters: 233348,
    seconds: 13431,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-nan-aighenan.shtml': {
    meters: 279508,
    seconds: 14101,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnabheithir.shtml': {
    meters: 282058,
    seconds: 13427,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnachaorainn.shtml': {
    meters: 215359,
    seconds: 11169,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/benstarav.shtml': {
    meters: 279508,
    seconds: 14101,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/bideannambian.shtml': {
    meters: 271697,
    seconds: 12867,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/binneinmor.shtml': {
    meters: 291705,
    seconds: 14086,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivebeag.shtml': {
    meters: 269616,
    seconds: 12743,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivemor.shtml': {
    meters: 266093,
    seconds: 12573,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/carnmordeargarete.shtml': {
    meters: 242500,
    seconds: 12672,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/chnodearg.shtml': {
    meters: 223440,
    seconds: 11755,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creagmeagaidh.shtml': {
    meters: 202734,
    seconds: 10648,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creise.shtml': {
    meters: 261905,
    seconds: 12470,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/easains.shtml': {
    meters: 223450,
    seconds: 11756,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gairich.shtml': {
    meters: 255841,
    seconds: 14095,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/greycorries.shtml': {
    meters: 237714,
    seconds: 12781,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gulvain.shtml': {
    meters: 261659,
    seconds: 13495,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ladhar-bheinn.shtml': {
    meters: 308875,
    seconds: 15830,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/lochlochymunros.shtml': {
    meters: 235793,
    seconds: 12816,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/luinne-bheinn.shtml': {
    meters: 308875,
    seconds: 15830,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ringofsteall.shtml': {
    meters: 256290,
    seconds: 13835,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgor-gaibhre.shtml': {
    meters: 233348,
    seconds: 13431,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgornaulaidh.shtml': {
    meters: 277008,
    seconds: 13128,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurr-mor.shtml': {
    meters: 267039,
    seconds: 15504,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurramhaoraich.shtml': {
    meters: 262726,
    seconds: 14638,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurreildemor.shtml': {
    meters: 291725,
    seconds: 14089,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrnaciche.shtml': {
    meters: 267039,
    seconds: 15504,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrthuilm.shtml': {
    meters: 267893,
    seconds: 13799,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/spideanmialach.shtml': {
    meters: 260788,
    seconds: 14486,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stob-ban-grey-corries.shtml': {
    meters: 238294,
    seconds: 12911,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobban.shtml': {
    meters: 253535,
    seconds: 13422,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobcoiranalbannaich.shtml': {
    meters: 279508,
    seconds: 14101,
  },
  'https://www.walkhighlands.co.uk/kintail/Achralaig.shtml': {
    meters: 249536,
    seconds: 13154,
  },
  'https://www.walkhighlands.co.uk/kintail/Aghlasbheinn.shtml': {
    meters: 273005,
    seconds: 14418,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnfhada.shtml': {
    meters: 273005,
    seconds: 14418,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnsgritheall.shtml': {
    meters: 299827,
    seconds: 16389,
  },
  'https://www.walkhighlands.co.uk/kintail/Brothersridge.shtml': {
    meters: 258376,
    seconds: 13582,
  },
  'https://www.walkhighlands.co.uk/kintail/Cistedhubh.shtml': {
    meters: 249536,
    seconds: 13154,
  },
  'https://www.walkhighlands.co.uk/kintail/Fivesisters.shtml': {
    meters: 258359,
    seconds: 13581,
  },
  'https://www.walkhighlands.co.uk/kintail/Glenshielridge.shtml': {
    meters: 250478,
    seconds: 13206,
  },
  'https://www.walkhighlands.co.uk/kintail/sgurrnanconbhairean.shtml': {
    meters: 242888,
    seconds: 12881,
  },
  'https://www.walkhighlands.co.uk/kintail/Thesaddle.shtml': {
    meters: 263255,
    seconds: 13810,
  },
  'https://www.walkhighlands.co.uk/lochlomond/an-caisteal.shtml': {
    meters: 226262,
    seconds: 10738,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-chabhair.shtml': {
    meters: 234253,
    seconds: 11052,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-ime.shtml': {
    meters: 262678,
    seconds: 11739,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-lomond.shtml': {
    meters: 236569,
    seconds: 10865,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-more.shtml': {
    meters: 219740,
    seconds: 10374,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vane.shtml': {
    meters: 243931,
    seconds: 11689,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vorlich-lomond.shtml': {
    meters: 243931,
    seconds: 11689,
  },
  'https://www.walkhighlands.co.uk/lochlomond/cruach-ardrain.shtml': {
    meters: 215450,
    seconds: 10888,
  },
  'https://www.walkhighlands.co.uk/lochness/Benwyvis.shtml': {
    meters: 210268,
    seconds: 10894,
  },
  'https://www.walkhighlands.co.uk/lochness/carn-eige.shtml': {
    meters: 226409,
    seconds: 12801,
  },
  'https://www.walkhighlands.co.uk/lochness/Ceathreamhnan.shtml': {
    meters: 242633,
    seconds: 14240,
  },
  'https://www.walkhighlands.co.uk/lochness/mullardoch-munros.shtml': {
    meters: 225814,
    seconds: 12914,
  },
  'https://www.walkhighlands.co.uk/lochness/strathfarrar-munros.shtml': {
    meters: 212180,
    seconds: 12165,
  },
  'https://www.walkhighlands.co.uk/lochness/Tollcreagach.shtml': {
    meters: 226409,
    seconds: 12801,
  },
  'https://www.walkhighlands.co.uk/mull/ben-more-mull.shtml': {
    meters: 336633,
    seconds: 20328,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-a-ghlo.shtml': {
    meters: 169903,
    seconds: 8188,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-dearg.shtml': {
    meters: 166863,
    seconds: 7844,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-heasgarnich.shtml': {
    meters: 206374,
    seconds: 10977,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-chonzie.shtml': {
    meters: 184925,
    seconds: 8727,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-lawers.shtml': {
    meters: 193213,
    seconds: 9855,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-vorlich.shtml': {
    meters: 193371,
    seconds: 9375,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-a-chlamain.shtml': {
    meters: 166860,
    seconds: 7844,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-mairg.shtml': {
    meters: 183282,
    seconds: 9471,
  },
  'https://www.walkhighlands.co.uk/perthshire/glas-tulaichean.shtml': {
    meters: 128234,
    seconds: 6566,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-buidhe.shtml': {
    meters: 200356,
    seconds: 10720,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-corranaich.shtml': {
    meters: 197708,
    seconds: 10276,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-garbh.shtml': {
    meters: 183491,
    seconds: 9215,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-ghaordaidh.shtml': {
    meters: 201126,
    seconds: 10456,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-nan-tarmachan.shtml': {
    meters: 193194,
    seconds: 9853,
  },
  'https://www.walkhighlands.co.uk/perthshire/schiehallion.shtml': {
    meters: 179432,
    seconds: 9134,
  },
  'https://www.walkhighlands.co.uk/perthshire/sgiath-chuil.shtml': {
    meters: 206374,
    seconds: 10977,
  },
  'https://www.walkhighlands.co.uk/perthshire/stuchd-an-lochain.shtml': {
    meters: 200425,
    seconds: 10720,
  },
  'https://www.walkhighlands.co.uk/skye/ambasteir.shtml': {
    meters: 331023,
    seconds: 16919,
  },
  'https://www.walkhighlands.co.uk/skye/blabheinn.shtml': {
    meters: 317170,
    seconds: 16662,
  },
  'https://www.walkhighlands.co.uk/skye/bruachnafrithe.shtml': {
    meters: 331494,
    seconds: 16947,
  },
  'https://www.walkhighlands.co.uk/skye/innpinn.shtml': {
    meters: 353353,
    seconds: 18475,
  },
  'https://www.walkhighlands.co.uk/skye/sgurr-mhic-choinnich.shtml': {
    meters: 354538,
    seconds: 18654,
  },
  'https://www.walkhighlands.co.uk/skye/sgurraghreadaidh.shtml': {
    meters: 352436,
    seconds: 18403,
  },
  'https://www.walkhighlands.co.uk/skye/sgurralasdair.shtml': {
    meters: 354538,
    seconds: 18654,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnabanachdich.shtml': {
    meters: 352436,
    seconds: 18403,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnaneag.shtml': {
    meters: 354538,
    seconds: 18654,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnangillean.shtml': {
    meters: 331140,
    seconds: 16961,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-hope.shtml': {
    meters: 295304,
    seconds: 16008,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-klibreck.shtml': {
    meters: 264606,
    seconds: 13787,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnalligin.shtml': {
    meters: 264908,
    seconds: 13919,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinneighe.shtml': {
    meters: 254169,
    seconds: 13056,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnliathmhor.shtml': {
    meters: 249187,
    seconds: 12600,
  },
  'https://www.walkhighlands.co.uk/torridon/bideinachoiresheasgaich.shtml': {
    meters: 264059,
    seconds: 13492,
  },
  'https://www.walkhighlands.co.uk/torridon/Fionnbheinn.shtml': {
    meters: 229322,
    seconds: 11742,
  },
  'https://www.walkhighlands.co.uk/torridon/Liathach.shtml': {
    meters: 256568,
    seconds: 13229,
  },
  'https://www.walkhighlands.co.uk/torridon/maoilelunndaidh.shtml': {
    meters: 245546,
    seconds: 12454,
  },
  'https://www.walkhighlands.co.uk/torridon/Maolcheandearg.shtml': {
    meters: 255294,
    seconds: 12979,
  },
  'https://www.walkhighlands.co.uk/torridon/Moruisg.shtml': {
    meters: 240499,
    seconds: 12181,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgorrruadh.shtml': {
    meters: 249180,
    seconds: 12644,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgurrchoinnich.shtml': {
    meters: 245551,
    seconds: 12455,
  },
  'https://www.walkhighlands.co.uk/torridon/Slioch.shtml': {
    meters: 244379,
    seconds: 12451,
  },
  'https://www.walkhighlands.co.uk/ullapool/amfaochagach.shtml': {
    meters: 227361,
    seconds: 11635,
  },
  'https://www.walkhighlands.co.uk/ullapool/anteallach.shtml': {
    meters: 256899,
    seconds: 13016,
  },
  'https://www.walkhighlands.co.uk/ullapool/beinndearg.shtml': {
    meters: 243675,
    seconds: 12361,
  },
  'https://www.walkhighlands.co.uk/ullapool/benmoreassynt.shtml': {
    meters: 292029,
    seconds: 14832,
  },
  'https://www.walkhighlands.co.uk/ullapool/fannichs.shtml': {
    meters: 227361,
    seconds: 11635,
  },
  'https://www.walkhighlands.co.uk/ullapool/fisherfield-6.shtml': {
    meters: 252948,
    seconds: 12821,
  },
  'https://www.walkhighlands.co.uk/ullapool/seana-bhraigh.shtml': {
    meters: 243726,
    seconds: 12334,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrbreac.shtml': {
    meters: 241365,
    seconds: 12273,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrnanclachgeala.shtml': {
    meters: 241356,
    seconds: 12273,
  },
}

const FROM_DUNDEE: {
  [name: string]: { meters: number; seconds: number }
} = {
  'https://www.walkhighlands.co.uk/angus/mayar-driesh.shtml': {
    meters: 58341,
    seconds: 3885,
  },
  'https://www.walkhighlands.co.uk/angus/mount-keen.shtml': {
    meters: 81539,
    seconds: 4431,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-achaladair.shtml': {
    meters: 143823,
    seconds: 7648,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-bhuidhe.shtml': {
    meters: 180269,
    seconds: 8785,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-dorain.shtml': {
    meters: 139085,
    seconds: 7401,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-eunaich.shtml': {
    meters: 151409,
    seconds: 8017,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-fhionnlaidh.shtml': {
    meters: 201584,
    seconds: 10984,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-mhanach.shtml': {
    meters: 131698,
    seconds: 7055,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-sgulaird.shtml': {
    meters: 197245,
    seconds: 10657,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-challum.shtml': {
    meters: 124909,
    seconds: 6692,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-cruachan.shtml': {
    meters: 157272,
    seconds: 8363,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-lui.shtml': {
    meters: 139396,
    seconds: 7404,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-oss.shtml': {
    meters: 126649,
    seconds: 6805,
  },
  'https://www.walkhighlands.co.uk/argyll/stob-ghabhar.shtml': {
    meters: 144660,
    seconds: 7872,
  },
  'https://www.walkhighlands.co.uk/cairngorms/a-mharconaich.shtml': {
    meters: 124602,
    seconds: 5331,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-sgarsoch.shtml': {
    meters: 93942,
    seconds: 5910,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-socach.shtml': {
    meters: 74343,
    seconds: 4637,
  },
  'https://www.walkhighlands.co.uk/cairngorms/aonach-beag.shtml': {
    meters: 146088,
    seconds: 8066,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-bhuird.shtml': {
    meters: 99761,
    seconds: 6443,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-chaorainn.shtml': {
    meters: 93900,
    seconds: 5906,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-bhrotain.shtml': {
    meters: 171356,
    seconds: 7837,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-iutharn-mhor.shtml': {
    meters: 90673,
    seconds: 5665,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-mheadhoin.shtml': {
    meters: 185667,
    seconds: 8236,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-udlamain.shtml': {
    meters: 120790,
    seconds: 5159,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-alder.shtml': {
    meters: 146088,
    seconds: 8066,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-avon.shtml': {
    meters: 88375,
    seconds: 5460,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-macdui.shtml': {
    meters: 93900,
    seconds: 5906,
  },
  'https://www.walkhighlands.co.uk/cairngorms/bynackmore.shtml': {
    meters: 180781,
    seconds: 7855,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairn-toul.shtml': {
    meters: 182152,
    seconds: 7915,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairnwell.shtml': {
    meters: 68860,
    seconds: 4361,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-a-mhaim.shtml': {
    meters: 93900,
    seconds: 5906,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-na-caim.shtml': {
    meters: 127535,
    seconds: 5435,
  },
  'https://www.walkhighlands.co.uk/cairngorms/geal-charn.shtml': {
    meters: 154203,
    seconds: 7398,
  },
  'https://www.walkhighlands.co.uk/cairngorms/glas-maol.shtml': {
    meters: 70967,
    seconds: 4472,
  },
  'https://www.walkhighlands.co.uk/cairngorms/macdui-cairngorm.shtml': {
    meters: 185667,
    seconds: 8236,
  },
  'https://www.walkhighlands.co.uk/cairngorms/meall-chuaich.shtml': {
    meters: 132604,
    seconds: 5642,
  },
  'https://www.walkhighlands.co.uk/cairngorms/monadhliath.shtml': {
    meters: 149947,
    seconds: 6756,
  },
  'https://www.walkhighlands.co.uk/cairngorms/mullach-clach-a-bhlair.shtml': {
    meters: 171356,
    seconds: 7837,
  },
  'https://www.walkhighlands.co.uk/cairngorms/sgor-gaoith.shtml': {
    meters: 168387,
    seconds: 7588,
  },
  'https://www.walkhighlands.co.uk/cairngorms/tolmount.shtml': {
    meters: 79906,
    seconds: 4969,
  },
  'https://www.walkhighlands.co.uk/cairngorms/white-mounth.shtml': {
    meters: 126252,
    seconds: 7062,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonacheagach.shtml': {
    meters: 168352,
    seconds: 8765,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonachmor.shtml': {
    meters: 211985,
    seconds: 10395,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-a-chlachair.shtml': {
    meters: 165109,
    seconds: 7444,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-na-lap.shtml': {
    meters: 189041,
    seconds: 9990,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-nan-aighenan.shtml': {
    meters: 176459,
    seconds: 10016,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnabheithir.shtml': {
    meters: 179009,
    seconds: 9342,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnachaorainn.shtml': {
    meters: 171051,
    seconds: 7729,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/benstarav.shtml': {
    meters: 176459,
    seconds: 10016,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/bideannambian.shtml': {
    meters: 168648,
    seconds: 8782,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/binneinmor.shtml': {
    meters: 188656,
    seconds: 10001,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivebeag.shtml': {
    meters: 166567,
    seconds: 8658,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivemor.shtml': {
    meters: 163044,
    seconds: 8488,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/carnmordeargarete.shtml': {
    meters: 198193,
    seconds: 9232,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/chnodearg.shtml': {
    meters: 179133,
    seconds: 8315,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creagmeagaidh.shtml': {
    meters: 158426,
    seconds: 7208,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creise.shtml': {
    meters: 158856,
    seconds: 8385,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/easains.shtml': {
    meters: 179143,
    seconds: 8316,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gairich.shtml': {
    meters: 239130,
    seconds: 11676,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/greycorries.shtml': {
    meters: 193407,
    seconds: 9341,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gulvain.shtml': {
    meters: 217352,
    seconds: 10055,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ladhar-bheinn.shtml': {
    meters: 264568,
    seconds: 12390,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/lochlochymunros.shtml': {
    meters: 212666,
    seconds: 10061,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/luinne-bheinn.shtml': {
    meters: 264568,
    seconds: 12390,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ringofsteall.shtml': {
    meters: 211983,
    seconds: 10395,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgor-gaibhre.shtml': {
    meters: 189041,
    seconds: 9990,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgornaulaidh.shtml': {
    meters: 173959,
    seconds: 9043,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurr-mor.shtml': {
    meters: 222732,
    seconds: 12064,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurramhaoraich.shtml': {
    meters: 246015,
    seconds: 12219,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurreildemor.shtml': {
    meters: 188676,
    seconds: 10004,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrnaciche.shtml': {
    meters: 222732,
    seconds: 12064,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrthuilm.shtml': {
    meters: 223586,
    seconds: 10359,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/spideanmialach.shtml': {
    meters: 244077,
    seconds: 12067,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stob-ban-grey-corries.shtml': {
    meters: 193987,
    seconds: 9471,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobban.shtml': {
    meters: 209228,
    seconds: 9982,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobcoiranalbannaich.shtml': {
    meters: 176459,
    seconds: 10016,
  },
  'https://www.walkhighlands.co.uk/kintail/Achralaig.shtml': {
    meters: 247066,
    seconds: 11471,
  },
  'https://www.walkhighlands.co.uk/kintail/Aghlasbheinn.shtml': {
    meters: 270535,
    seconds: 12735,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnfhada.shtml': {
    meters: 270535,
    seconds: 12735,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnsgritheall.shtml': {
    meters: 297357,
    seconds: 14706,
  },
  'https://www.walkhighlands.co.uk/kintail/Brothersridge.shtml': {
    meters: 255906,
    seconds: 11899,
  },
  'https://www.walkhighlands.co.uk/kintail/Cistedhubh.shtml': {
    meters: 247066,
    seconds: 11471,
  },
  'https://www.walkhighlands.co.uk/kintail/Fivesisters.shtml': {
    meters: 255889,
    seconds: 11898,
  },
  'https://www.walkhighlands.co.uk/kintail/Glenshielridge.shtml': {
    meters: 248008,
    seconds: 11523,
  },
  'https://www.walkhighlands.co.uk/kintail/sgurrnanconbhairean.shtml': {
    meters: 240418,
    seconds: 11198,
  },
  'https://www.walkhighlands.co.uk/kintail/Thesaddle.shtml': {
    meters: 260785,
    seconds: 12127,
  },
  'https://www.walkhighlands.co.uk/lochlomond/an-caisteal.shtml': {
    meters: 123213,
    seconds: 6653,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-chabhair.shtml': {
    meters: 131204,
    seconds: 6967,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-ime.shtml': {
    meters: 159629,
    seconds: 7654,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-lomond.shtml': {
    meters: 133520,
    seconds: 6780,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-more.shtml': {
    meters: 116691,
    seconds: 6289,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vane.shtml': {
    meters: 140882,
    seconds: 7604,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vorlich-lomond.shtml': {
    meters: 140882,
    seconds: 7604,
  },
  'https://www.walkhighlands.co.uk/lochlomond/cruach-ardrain.shtml': {
    meters: 112401,
    seconds: 6803,
  },
  'https://www.walkhighlands.co.uk/lochness/Benwyvis.shtml': {
    meters: 262712,
    seconds: 11111,
  },
  'https://www.walkhighlands.co.uk/lochness/carn-eige.shtml': {
    meters: 279430,
    seconds: 13004,
  },
  'https://www.walkhighlands.co.uk/lochness/Ceathreamhnan.shtml': {
    meters: 295654,
    seconds: 14443,
  },
  'https://www.walkhighlands.co.uk/lochness/mullardoch-munros.shtml': {
    meters: 278835,
    seconds: 13117,
  },
  'https://www.walkhighlands.co.uk/lochness/strathfarrar-munros.shtml': {
    meters: 269196,
    seconds: 12276,
  },
  'https://www.walkhighlands.co.uk/lochness/Tollcreagach.shtml': {
    meters: 279430,
    seconds: 13004,
  },
  'https://www.walkhighlands.co.uk/mull/ben-more-mull.shtml': {
    meters: 233584,
    seconds: 16243,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-a-ghlo.shtml': {
    meters: 96958,
    seconds: 4626,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-dearg.shtml': {
    meters: 93918,
    seconds: 4282,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-heasgarnich.shtml': {
    meters: 118766,
    seconds: 7075,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-chonzie.shtml': {
    meters: 81876,
    seconds: 4642,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-lawers.shtml': {
    meters: 120269,
    seconds: 6293,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-vorlich.shtml': {
    meters: 90322,
    seconds: 5290,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-a-chlamain.shtml': {
    meters: 93915,
    seconds: 4282,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-mairg.shtml': {
    meters: 110338,
    seconds: 5909,
  },
  'https://www.walkhighlands.co.uk/perthshire/glas-tulaichean.shtml': {
    meters: 60160,
    seconds: 3978,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-buidhe.shtml': {
    meters: 127412,
    seconds: 7158,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-corranaich.shtml': {
    meters: 124764,
    seconds: 6714,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-garbh.shtml': {
    meters: 110547,
    seconds: 5653,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-ghaordaidh.shtml': {
    meters: 113518,
    seconds: 6554,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-nan-tarmachan.shtml': {
    meters: 120250,
    seconds: 6291,
  },
  'https://www.walkhighlands.co.uk/perthshire/schiehallion.shtml': {
    meters: 106488,
    seconds: 5572,
  },
  'https://www.walkhighlands.co.uk/perthshire/sgiath-chuil.shtml': {
    meters: 118766,
    seconds: 7075,
  },
  'https://www.walkhighlands.co.uk/perthshire/stuchd-an-lochain.shtml': {
    meters: 127481,
    seconds: 7158,
  },
  'https://www.walkhighlands.co.uk/skye/ambasteir.shtml': {
    meters: 332054,
    seconds: 15683,
  },
  'https://www.walkhighlands.co.uk/skye/blabheinn.shtml': {
    meters: 318201,
    seconds: 15426,
  },
  'https://www.walkhighlands.co.uk/skye/bruachnafrithe.shtml': {
    meters: 332525,
    seconds: 15711,
  },
  'https://www.walkhighlands.co.uk/skye/innpinn.shtml': {
    meters: 354384,
    seconds: 17239,
  },
  'https://www.walkhighlands.co.uk/skye/sgurr-mhic-choinnich.shtml': {
    meters: 355569,
    seconds: 17418,
  },
  'https://www.walkhighlands.co.uk/skye/sgurraghreadaidh.shtml': {
    meters: 353467,
    seconds: 17167,
  },
  'https://www.walkhighlands.co.uk/skye/sgurralasdair.shtml': {
    meters: 355569,
    seconds: 17418,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnabanachdich.shtml': {
    meters: 353467,
    seconds: 17167,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnaneag.shtml': {
    meters: 355569,
    seconds: 17418,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnangillean.shtml': {
    meters: 332171,
    seconds: 15725,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-hope.shtml': {
    meters: 347748,
    seconds: 16225,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-klibreck.shtml': {
    meters: 317050,
    seconds: 14004,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnalligin.shtml': {
    meters: 317352,
    seconds: 14136,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinneighe.shtml': {
    meters: 306613,
    seconds: 13273,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnliathmhor.shtml': {
    meters: 301631,
    seconds: 12817,
  },
  'https://www.walkhighlands.co.uk/torridon/bideinachoiresheasgaich.shtml': {
    meters: 316503,
    seconds: 13709,
  },
  'https://www.walkhighlands.co.uk/torridon/Fionnbheinn.shtml': {
    meters: 281766,
    seconds: 11959,
  },
  'https://www.walkhighlands.co.uk/torridon/Liathach.shtml': {
    meters: 309012,
    seconds: 13446,
  },
  'https://www.walkhighlands.co.uk/torridon/maoilelunndaidh.shtml': {
    meters: 297990,
    seconds: 12671,
  },
  'https://www.walkhighlands.co.uk/torridon/Maolcheandearg.shtml': {
    meters: 307738,
    seconds: 13196,
  },
  'https://www.walkhighlands.co.uk/torridon/Moruisg.shtml': {
    meters: 292943,
    seconds: 12398,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgorrruadh.shtml': {
    meters: 301624,
    seconds: 12861,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgurrchoinnich.shtml': {
    meters: 297995,
    seconds: 12672,
  },
  'https://www.walkhighlands.co.uk/torridon/Slioch.shtml': {
    meters: 296823,
    seconds: 12668,
  },
  'https://www.walkhighlands.co.uk/ullapool/amfaochagach.shtml': {
    meters: 279805,
    seconds: 11852,
  },
  'https://www.walkhighlands.co.uk/ullapool/anteallach.shtml': {
    meters: 309343,
    seconds: 13233,
  },
  'https://www.walkhighlands.co.uk/ullapool/beinndearg.shtml': {
    meters: 296119,
    seconds: 12578,
  },
  'https://www.walkhighlands.co.uk/ullapool/benmoreassynt.shtml': {
    meters: 344473,
    seconds: 15049,
  },
  'https://www.walkhighlands.co.uk/ullapool/fannichs.shtml': {
    meters: 279805,
    seconds: 11852,
  },
  'https://www.walkhighlands.co.uk/ullapool/fisherfield-6.shtml': {
    meters: 305392,
    seconds: 13038,
  },
  'https://www.walkhighlands.co.uk/ullapool/seana-bhraigh.shtml': {
    meters: 296170,
    seconds: 12551,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrbreac.shtml': {
    meters: 293809,
    seconds: 12490,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrnanclachgeala.shtml': {
    meters: 293800,
    seconds: 12490,
  },
}

export const FROM_INVERNESS: {
  [name: string]: { meters: number; seconds: number }
} = {
  'https://www.walkhighlands.co.uk/angus/mayar-driesh.shtml': {
    meters: 228505,
    seconds: 11566,
  },
  'https://www.walkhighlands.co.uk/angus/mount-keen.shtml': {
    meters: 198219,
    seconds: 11209,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-achaladair.shtml': {
    meters: 164279,
    seconds: 8793,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-bhuidhe.shtml': {
    meters: 236088,
    seconds: 12313,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-dorain.shtml': {
    meters: 168594,
    seconds: 8946,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-eunaich.shtml': {
    meters: 201182,
    seconds: 10546,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-fhionnlaidh.shtml': {
    meters: 160172,
    seconds: 8907,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-mhanach.shtml': {
    meters: 175981,
    seconds: 9306,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-sgulaird.shtml': {
    meters: 157018,
    seconds: 8642,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-challum.shtml': {
    meters: 182771,
    seconds: 9651,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-cruachan.shtml': {
    meters: 188949,
    seconds: 10292,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-lui.shtml': {
    meters: 189169,
    seconds: 9933,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-oss.shtml': {
    meters: 181266,
    seconds: 9642,
  },
  'https://www.walkhighlands.co.uk/argyll/stob-ghabhar.shtml': {
    meters: 173953,
    seconds: 9431,
  },
  'https://www.walkhighlands.co.uk/cairngorms/a-mharconaich.shtml': {
    meters: 97069,
    seconds: 4227,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-sgarsoch.shtml': {
    meters: 148161,
    seconds: 8147,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-socach.shtml': {
    meters: 146584,
    seconds: 7837,
  },
  'https://www.walkhighlands.co.uk/cairngorms/aonach-beag.shtml': {
    meters: 110744,
    seconds: 6600,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-bhuird.shtml': {
    meters: 153980,
    seconds: 8680,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-chaorainn.shtml': {
    meters: 148119,
    seconds: 8143,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-bhrotain.shtml': {
    meters: 71321,
    seconds: 3818,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-iutharn-mhor.shtml': {
    meters: 144892,
    seconds: 7902,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-mheadhoin.shtml': {
    meters: 71444,
    seconds: 3652,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-udlamain.shtml': {
    meters: 100753,
    seconds: 4329,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-alder.shtml': {
    meters: 110744,
    seconds: 6600,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-avon.shtml': {
    meters: 133105,
    seconds: 7124,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-macdui.shtml': {
    meters: 148119,
    seconds: 8143,
  },
  'https://www.walkhighlands.co.uk/cairngorms/bynackmore.shtml': {
    meters: 66558,
    seconds: 3271,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairn-toul.shtml': {
    meters: 67929,
    seconds: 3331,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairnwell.shtml': {
    meters: 152068,
    seconds: 8123,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-a-mhaim.shtml': {
    meters: 148119,
    seconds: 8143,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-na-caim.shtml': {
    meters: 94011,
    seconds: 4045,
  },
  'https://www.walkhighlands.co.uk/cairngorms/geal-charn.shtml': {
    meters: 98591,
    seconds: 5269,
  },
  'https://www.walkhighlands.co.uk/cairngorms/glas-maol.shtml': {
    meters: 149961,
    seconds: 8008,
  },
  'https://www.walkhighlands.co.uk/cairngorms/macdui-cairngorm.shtml': {
    meters: 71444,
    seconds: 3652,
  },
  'https://www.walkhighlands.co.uk/cairngorms/meall-chuaich.shtml': {
    meters: 88939,
    seconds: 3831,
  },
  'https://www.walkhighlands.co.uk/cairngorms/monadhliath.shtml': {
    meters: 77588,
    seconds: 3886,
  },
  'https://www.walkhighlands.co.uk/cairngorms/mullach-clach-a-bhlair.shtml': {
    meters: 71321,
    seconds: 3818,
  },
  'https://www.walkhighlands.co.uk/cairngorms/sgor-gaoith.shtml': {
    meters: 68352,
    seconds: 3569,
  },
  'https://www.walkhighlands.co.uk/cairngorms/tolmount.shtml': {
    meters: 141034,
    seconds: 7561,
  },
  'https://www.walkhighlands.co.uk/cairngorms/white-mounth.shtml': {
    meters: 130253,
    seconds: 7392,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonacheagach.shtml': {
    meters: 139328,
    seconds: 7590,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonachmor.shtml': {
    meters: 114241,
    seconds: 6687,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-a-chlachair.shtml': {
    meters: 110808,
    seconds: 5391,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-na-lap.shtml': {
    meters: 134740,
    seconds: 7938,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-nan-aighenan.shtml': {
    meters: 163912,
    seconds: 9669,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnabheithir.shtml': {
    meters: 129072,
    seconds: 7135,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnachaorainn.shtml': {
    meters: 116751,
    seconds: 5676,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/benstarav.shtml': {
    meters: 163912,
    seconds: 9669,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/bideannambian.shtml': {
    meters: 139031,
    seconds: 7573,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/binneinmor.shtml': {
    meters: 139032,
    seconds: 7741,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivebeag.shtml': {
    meters: 141113,
    seconds: 7699,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivemor.shtml': {
    meters: 144635,
    seconds: 7872,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/carnmordeargarete.shtml': {
    meters: 100449,
    seconds: 5524,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/chnodearg.shtml': {
    meters: 106745,
    seconds: 5913,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creagmeagaidh.shtml': {
    meters: 104126,
    seconds: 5155,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creise.shtml': {
    meters: 151300,
    seconds: 8275,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/easains.shtml': {
    meters: 106755,
    seconds: 5914,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gairich.shtml': {
    meters: 92503,
    seconds: 5486,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/greycorries.shtml': {
    meters: 95662,
    seconds: 5633,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gulvain.shtml': {
    meters: 119608,
    seconds: 6346,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ladhar-bheinn.shtml': {
    meters: 166824,
    seconds: 8681,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/lochlochymunros.shtml': {
    meters: 72455,
    seconds: 4207,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/luinne-bheinn.shtml': {
    meters: 166824,
    seconds: 8681,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ringofsteall.shtml': {
    meters: 114239,
    seconds: 6687,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgor-gaibhre.shtml': {
    meters: 134740,
    seconds: 7938,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgornaulaidh.shtml': {
    meters: 133720,
    seconds: 7310,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurr-mor.shtml': {
    meters: 121564,
    seconds: 8142,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurramhaoraich.shtml': {
    meters: 99388,
    seconds: 6029,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurreildemor.shtml': {
    meters: 139051,
    seconds: 7744,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrnaciche.shtml': {
    meters: 121564,
    seconds: 8142,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrthuilm.shtml': {
    meters: 125842,
    seconds: 6650,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/spideanmialach.shtml': {
    meters: 97450,
    seconds: 5877,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stob-ban-grey-corries.shtml': {
    meters: 96242,
    seconds: 5763,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobban.shtml': {
    meters: 111484,
    seconds: 6274,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobcoiranalbannaich.shtml': {
    meters: 163912,
    seconds: 9669,
  },
  'https://www.walkhighlands.co.uk/kintail/Achralaig.shtml': {
    meters: 81605,
    seconds: 4117,
  },
  'https://www.walkhighlands.co.uk/kintail/Aghlasbheinn.shtml': {
    meters: 105074,
    seconds: 5381,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnfhada.shtml': {
    meters: 105074,
    seconds: 5381,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnsgritheall.shtml': {
    meters: 131896,
    seconds: 7352,
  },
  'https://www.walkhighlands.co.uk/kintail/Brothersridge.shtml': {
    meters: 90445,
    seconds: 4545,
  },
  'https://www.walkhighlands.co.uk/kintail/Cistedhubh.shtml': {
    meters: 81605,
    seconds: 4117,
  },
  'https://www.walkhighlands.co.uk/kintail/Fivesisters.shtml': {
    meters: 90428,
    seconds: 4544,
  },
  'https://www.walkhighlands.co.uk/kintail/Glenshielridge.shtml': {
    meters: 82547,
    seconds: 4169,
  },
  'https://www.walkhighlands.co.uk/kintail/sgurrnanconbhairean.shtml': {
    meters: 74957,
    seconds: 3844,
  },
  'https://www.walkhighlands.co.uk/kintail/Thesaddle.shtml': {
    meters: 95324,
    seconds: 4773,
  },
  'https://www.walkhighlands.co.uk/lochlomond/an-caisteal.shtml': {
    meters: 189086,
    seconds: 9991,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-chabhair.shtml': {
    meters: 197078,
    seconds: 10305,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-ime.shtml': {
    meters: 216850,
    seconds: 11594,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-lomond.shtml': {
    meters: 277835,
    seconds: 12585,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-more.shtml': {
    meters: 189283,
    seconds: 9702,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vane.shtml': {
    meters: 206756,
    seconds: 10942,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vorlich-lomond.shtml': {
    meters: 206756,
    seconds: 10942,
  },
  'https://www.walkhighlands.co.uk/lochlomond/cruach-ardrain.shtml': {
    meters: 201040,
    seconds: 11122,
  },
  'https://www.walkhighlands.co.uk/lochness/Benwyvis.shtml': {
    meters: 46853,
    seconds: 2416,
  },
  'https://www.walkhighlands.co.uk/lochness/carn-eige.shtml': {
    meters: 58478,
    seconds: 3764,
  },
  'https://www.walkhighlands.co.uk/lochness/Ceathreamhnan.shtml': {
    meters: 74702,
    seconds: 5203,
  },
  'https://www.walkhighlands.co.uk/lochness/mullardoch-munros.shtml': {
    meters: 57883,
    seconds: 3877,
  },
  'https://www.walkhighlands.co.uk/lochness/strathfarrar-munros.shtml': {
    meters: 45121,
    seconds: 3212,
  },
  'https://www.walkhighlands.co.uk/lochness/Tollcreagach.shtml': {
    meters: 58478,
    seconds: 3764,
  },
  'https://www.walkhighlands.co.uk/mull/ben-more-mull.shtml': {
    meters: 196598,
    seconds: 14453,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-a-ghlo.shtml': {
    meters: 133374,
    seconds: 6067,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-dearg.shtml': {
    meters: 130334,
    seconds: 5723,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-heasgarnich.shtml': {
    meters: 180512,
    seconds: 9685,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-chonzie.shtml': {
    meters: 212558,
    seconds: 9996,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-lawers.shtml': {
    meters: 167351,
    seconds: 8562,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-vorlich.shtml': {
    meters: 189388,
    seconds: 10032,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-a-chlamain.shtml': {
    meters: 130331,
    seconds: 5723,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-mairg.shtml': {
    meters: 154155,
    seconds: 7922,
  },
  'https://www.walkhighlands.co.uk/perthshire/glas-tulaichean.shtml': {
    meters: 179915,
    seconds: 8648,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-buidhe.shtml': {
    meters: 171229,
    seconds: 9171,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-corranaich.shtml': {
    meters: 171846,
    seconds: 8983,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-garbh.shtml': {
    meters: 157629,
    seconds: 7922,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-ghaordaidh.shtml': {
    meters: 175264,
    seconds: 9164,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-nan-tarmachan.shtml': {
    meters: 167332,
    seconds: 8560,
  },
  'https://www.walkhighlands.co.uk/perthshire/schiehallion.shtml': {
    meters: 138296,
    seconds: 6761,
  },
  'https://www.walkhighlands.co.uk/perthshire/sgiath-chuil.shtml': {
    meters: 180512,
    seconds: 9685,
  },
  'https://www.walkhighlands.co.uk/perthshire/stuchd-an-lochain.shtml': {
    meters: 171298,
    seconds: 9171,
  },
  'https://www.walkhighlands.co.uk/skye/ambasteir.shtml': {
    meters: 166593,
    seconds: 8329,
  },
  'https://www.walkhighlands.co.uk/skye/blabheinn.shtml': {
    meters: 152740,
    seconds: 8072,
  },
  'https://www.walkhighlands.co.uk/skye/bruachnafrithe.shtml': {
    meters: 167064,
    seconds: 8357,
  },
  'https://www.walkhighlands.co.uk/skye/innpinn.shtml': {
    meters: 188923,
    seconds: 9885,
  },
  'https://www.walkhighlands.co.uk/skye/sgurr-mhic-choinnich.shtml': {
    meters: 190108,
    seconds: 10064,
  },
  'https://www.walkhighlands.co.uk/skye/sgurraghreadaidh.shtml': {
    meters: 188006,
    seconds: 9813,
  },
  'https://www.walkhighlands.co.uk/skye/sgurralasdair.shtml': {
    meters: 190108,
    seconds: 10064,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnabanachdich.shtml': {
    meters: 188006,
    seconds: 9813,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnaneag.shtml': {
    meters: 190108,
    seconds: 10064,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnangillean.shtml': {
    meters: 166710,
    seconds: 8371,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-hope.shtml': {
    meters: 131889,
    seconds: 7530,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-klibreck.shtml': {
    meters: 101191,
    seconds: 5309,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnalligin.shtml': {
    meters: 101493,
    seconds: 5441,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinneighe.shtml': {
    meters: 90754,
    seconds: 4578,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnliathmhor.shtml': {
    meters: 85772,
    seconds: 4122,
  },
  'https://www.walkhighlands.co.uk/torridon/bideinachoiresheasgaich.shtml': {
    meters: 100644,
    seconds: 5014,
  },
  'https://www.walkhighlands.co.uk/torridon/Fionnbheinn.shtml': {
    meters: 65907,
    seconds: 3264,
  },
  'https://www.walkhighlands.co.uk/torridon/Liathach.shtml': {
    meters: 93153,
    seconds: 4751,
  },
  'https://www.walkhighlands.co.uk/torridon/maoilelunndaidh.shtml': {
    meters: 82131,
    seconds: 3976,
  },
  'https://www.walkhighlands.co.uk/torridon/Maolcheandearg.shtml': {
    meters: 91879,
    seconds: 4501,
  },
  'https://www.walkhighlands.co.uk/torridon/Moruisg.shtml': {
    meters: 77084,
    seconds: 3703,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgorrruadh.shtml': {
    meters: 85765,
    seconds: 4166,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgurrchoinnich.shtml': {
    meters: 82136,
    seconds: 3977,
  },
  'https://www.walkhighlands.co.uk/torridon/Slioch.shtml': {
    meters: 80964,
    seconds: 3973,
  },
  'https://www.walkhighlands.co.uk/ullapool/amfaochagach.shtml': {
    meters: 63946,
    seconds: 3157,
  },
  'https://www.walkhighlands.co.uk/ullapool/anteallach.shtml': {
    meters: 93484,
    seconds: 4538,
  },
  'https://www.walkhighlands.co.uk/ullapool/beinndearg.shtml': {
    meters: 80260,
    seconds: 3883,
  },
  'https://www.walkhighlands.co.uk/ullapool/benmoreassynt.shtml': {
    meters: 128614,
    seconds: 6354,
  },
  'https://www.walkhighlands.co.uk/ullapool/fannichs.shtml': {
    meters: 63946,
    seconds: 3157,
  },
  'https://www.walkhighlands.co.uk/ullapool/fisherfield-6.shtml': {
    meters: 89533,
    seconds: 4343,
  },
  'https://www.walkhighlands.co.uk/ullapool/seana-bhraigh.shtml': {
    meters: 80311,
    seconds: 3856,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrbreac.shtml': {
    meters: 77950,
    seconds: 3795,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrnanclachgeala.shtml': {
    meters: 77941,
    seconds: 3795,
  },
}

const FROM_PERTH: {
  [name: string]: { meters: number; seconds: number }
} = {
  'https://www.walkhighlands.co.uk/angus/mayar-driesh.shtml': {
    meters: 73904,
    seconds: 4950,
  },
  'https://www.walkhighlands.co.uk/angus/mount-keen.shtml': {
    meters: 114159,
    seconds: 5762,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-achaladair.shtml': {
    meters: 109235,
    seconds: 6261,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-bhuidhe.shtml': {
    meters: 145682,
    seconds: 7398,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-dorain.shtml': {
    meters: 104497,
    seconds: 6014,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-eunaich.shtml': {
    meters: 116821,
    seconds: 6630,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-fhionnlaidh.shtml': {
    meters: 166996,
    seconds: 9597,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-mhanach.shtml': {
    meters: 97110,
    seconds: 5668,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-sgulaird.shtml': {
    meters: 162657,
    seconds: 9270,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-challum.shtml': {
    meters: 90321,
    seconds: 5305,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-cruachan.shtml': {
    meters: 122684,
    seconds: 6976,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-lui.shtml': {
    meters: 104808,
    seconds: 6017,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-oss.shtml': {
    meters: 92061,
    seconds: 5418,
  },
  'https://www.walkhighlands.co.uk/argyll/stob-ghabhar.shtml': {
    meters: 110072,
    seconds: 6485,
  },
  'https://www.walkhighlands.co.uk/cairngorms/a-mharconaich.shtml': {
    meters: 85562,
    seconds: 3876,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-sgarsoch.shtml': {
    meters: 90610,
    seconds: 5722,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-socach.shtml': {
    meters: 71011,
    seconds: 4449,
  },
  'https://www.walkhighlands.co.uk/cairngorms/aonach-beag.shtml': {
    meters: 107048,
    seconds: 6611,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-bhuird.shtml': {
    meters: 96429,
    seconds: 6255,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-chaorainn.shtml': {
    meters: 90568,
    seconds: 5718,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-bhrotain.shtml': {
    meters: 132316,
    seconds: 6382,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-iutharn-mhor.shtml': {
    meters: 87341,
    seconds: 5477,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-mheadhoin.shtml': {
    meters: 146627,
    seconds: 6781,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-udlamain.shtml': {
    meters: 81750,
    seconds: 3704,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-alder.shtml': {
    meters: 107048,
    seconds: 6611,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-avon.shtml': {
    meters: 85043,
    seconds: 5272,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-macdui.shtml': {
    meters: 90568,
    seconds: 5718,
  },
  'https://www.walkhighlands.co.uk/cairngorms/bynackmore.shtml': {
    meters: 141741,
    seconds: 6400,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairn-toul.shtml': {
    meters: 143112,
    seconds: 6460,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairnwell.shtml': {
    meters: 65528,
    seconds: 4173,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-a-mhaim.shtml': {
    meters: 90568,
    seconds: 5718,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-na-caim.shtml': {
    meters: 88495,
    seconds: 3980,
  },
  'https://www.walkhighlands.co.uk/cairngorms/geal-charn.shtml': {
    meters: 115163,
    seconds: 5943,
  },
  'https://www.walkhighlands.co.uk/cairngorms/glas-maol.shtml': {
    meters: 67635,
    seconds: 4284,
  },
  'https://www.walkhighlands.co.uk/cairngorms/macdui-cairngorm.shtml': {
    meters: 146627,
    seconds: 6781,
  },
  'https://www.walkhighlands.co.uk/cairngorms/meall-chuaich.shtml': {
    meters: 93564,
    seconds: 4187,
  },
  'https://www.walkhighlands.co.uk/cairngorms/monadhliath.shtml': {
    meters: 110907,
    seconds: 5301,
  },
  'https://www.walkhighlands.co.uk/cairngorms/mullach-clach-a-bhlair.shtml': {
    meters: 132316,
    seconds: 6382,
  },
  'https://www.walkhighlands.co.uk/cairngorms/sgor-gaoith.shtml': {
    meters: 129347,
    seconds: 6133,
  },
  'https://www.walkhighlands.co.uk/cairngorms/tolmount.shtml': {
    meters: 76574,
    seconds: 4781,
  },
  'https://www.walkhighlands.co.uk/cairngorms/white-mounth.shtml': {
    meters: 120371,
    seconds: 7401,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonacheagach.shtml': {
    meters: 133764,
    seconds: 7378,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonachmor.shtml': {
    meters: 172945,
    seconds: 8940,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-a-chlachair.shtml': {
    meters: 126069,
    seconds: 5989,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-na-lap.shtml': {
    meters: 150001,
    seconds: 8535,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-nan-aighenan.shtml': {
    meters: 141871,
    seconds: 8629,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnabheithir.shtml': {
    meters: 144421,
    seconds: 7955,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnachaorainn.shtml': {
    meters: 132011,
    seconds: 6274,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/benstarav.shtml': {
    meters: 141871,
    seconds: 8629,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/bideannambian.shtml': {
    meters: 134060,
    seconds: 7395,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/binneinmor.shtml': {
    meters: 154068,
    seconds: 8614,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivebeag.shtml': {
    meters: 131979,
    seconds: 7271,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivemor.shtml': {
    meters: 128456,
    seconds: 7101,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/carnmordeargarete.shtml': {
    meters: 159153,
    seconds: 7777,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/chnodearg.shtml': {
    meters: 140093,
    seconds: 6860,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creagmeagaidh.shtml': {
    meters: 119386,
    seconds: 5753,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creise.shtml': {
    meters: 124268,
    seconds: 6998,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/easains.shtml': {
    meters: 140103,
    seconds: 6861,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gairich.shtml': {
    meters: 200090,
    seconds: 10221,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/greycorries.shtml': {
    meters: 154367,
    seconds: 7886,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gulvain.shtml': {
    meters: 178312,
    seconds: 8600,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ladhar-bheinn.shtml': {
    meters: 225528,
    seconds: 10935,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/lochlochymunros.shtml': {
    meters: 173626,
    seconds: 8606,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/luinne-bheinn.shtml': {
    meters: 225528,
    seconds: 10935,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ringofsteall.shtml': {
    meters: 172943,
    seconds: 8940,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgor-gaibhre.shtml': {
    meters: 150001,
    seconds: 8535,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgornaulaidh.shtml': {
    meters: 139371,
    seconds: 7656,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurr-mor.shtml': {
    meters: 183692,
    seconds: 10609,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurramhaoraich.shtml': {
    meters: 206975,
    seconds: 10764,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurreildemor.shtml': {
    meters: 154088,
    seconds: 8617,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrnaciche.shtml': {
    meters: 183692,
    seconds: 10609,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrthuilm.shtml': {
    meters: 184546,
    seconds: 8904,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/spideanmialach.shtml': {
    meters: 205037,
    seconds: 10612,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stob-ban-grey-corries.shtml': {
    meters: 154947,
    seconds: 8016,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobban.shtml': {
    meters: 170188,
    seconds: 8527,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobcoiranalbannaich.shtml': {
    meters: 141871,
    seconds: 8629,
  },
  'https://www.walkhighlands.co.uk/kintail/Achralaig.shtml': {
    meters: 208026,
    seconds: 10016,
  },
  'https://www.walkhighlands.co.uk/kintail/Aghlasbheinn.shtml': {
    meters: 231495,
    seconds: 11280,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnfhada.shtml': {
    meters: 231495,
    seconds: 11280,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnsgritheall.shtml': {
    meters: 258317,
    seconds: 13251,
  },
  'https://www.walkhighlands.co.uk/kintail/Brothersridge.shtml': {
    meters: 216866,
    seconds: 10444,
  },
  'https://www.walkhighlands.co.uk/kintail/Cistedhubh.shtml': {
    meters: 208026,
    seconds: 10016,
  },
  'https://www.walkhighlands.co.uk/kintail/Fivesisters.shtml': {
    meters: 216849,
    seconds: 10443,
  },
  'https://www.walkhighlands.co.uk/kintail/Glenshielridge.shtml': {
    meters: 208968,
    seconds: 10068,
  },
  'https://www.walkhighlands.co.uk/kintail/sgurrnanconbhairean.shtml': {
    meters: 201378,
    seconds: 9743,
  },
  'https://www.walkhighlands.co.uk/kintail/Thesaddle.shtml': {
    meters: 221745,
    seconds: 10672,
  },
  'https://www.walkhighlands.co.uk/lochlomond/an-caisteal.shtml': {
    meters: 88625,
    seconds: 5266,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-chabhair.shtml': {
    meters: 96616,
    seconds: 5580,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-ime.shtml': {
    meters: 125042,
    seconds: 6267,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-lomond.shtml': {
    meters: 98933,
    seconds: 5393,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-more.shtml': {
    meters: 82103,
    seconds: 4902,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vane.shtml': {
    meters: 106294,
    seconds: 6217,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vorlich-lomond.shtml': {
    meters: 106294,
    seconds: 6217,
  },
  'https://www.walkhighlands.co.uk/lochlomond/cruach-ardrain.shtml': {
    meters: 77813,
    seconds: 5416,
  },
  'https://www.walkhighlands.co.uk/lochness/Benwyvis.shtml': {
    meters: 223672,
    seconds: 9656,
  },
  'https://www.walkhighlands.co.uk/lochness/carn-eige.shtml': {
    meters: 240390,
    seconds: 11549,
  },
  'https://www.walkhighlands.co.uk/lochness/Ceathreamhnan.shtml': {
    meters: 256614,
    seconds: 12988,
  },
  'https://www.walkhighlands.co.uk/lochness/mullardoch-munros.shtml': {
    meters: 239795,
    seconds: 11662,
  },
  'https://www.walkhighlands.co.uk/lochness/strathfarrar-munros.shtml': {
    meters: 230156,
    seconds: 10821,
  },
  'https://www.walkhighlands.co.uk/lochness/Tollcreagach.shtml': {
    meters: 240390,
    seconds: 11549,
  },
  'https://www.walkhighlands.co.uk/mull/ben-more-mull.shtml': {
    meters: 198996,
    seconds: 14856,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-a-ghlo.shtml': {
    meters: 57918,
    seconds: 3171,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-dearg.shtml': {
    meters: 54878,
    seconds: 2827,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-heasgarnich.shtml': {
    meters: 84178,
    seconds: 5688,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-chonzie.shtml': {
    meters: 47288,
    seconds: 3255,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-lawers.shtml': {
    meters: 81229,
    seconds: 4837,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-vorlich.shtml': {
    meters: 55734,
    seconds: 3903,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-a-chlamain.shtml': {
    meters: 54875,
    seconds: 2827,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-mairg.shtml': {
    meters: 71298,
    seconds: 4453,
  },
  'https://www.walkhighlands.co.uk/perthshire/glas-tulaichean.shtml': {
    meters: 56828,
    seconds: 3790,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-buidhe.shtml': {
    meters: 88372,
    seconds: 5702,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-corranaich.shtml': {
    meters: 85724,
    seconds: 5258,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-garbh.shtml': {
    meters: 71507,
    seconds: 4197,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-ghaordaidh.shtml': {
    meters: 78930,
    seconds: 5167,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-nan-tarmachan.shtml': {
    meters: 81210,
    seconds: 4835,
  },
  'https://www.walkhighlands.co.uk/perthshire/schiehallion.shtml': {
    meters: 67448,
    seconds: 4116,
  },
  'https://www.walkhighlands.co.uk/perthshire/sgiath-chuil.shtml': {
    meters: 84178,
    seconds: 5688,
  },
  'https://www.walkhighlands.co.uk/perthshire/stuchd-an-lochain.shtml': {
    meters: 88441,
    seconds: 5702,
  },
  'https://www.walkhighlands.co.uk/skye/ambasteir.shtml': {
    meters: 293014,
    seconds: 14228,
  },
  'https://www.walkhighlands.co.uk/skye/blabheinn.shtml': {
    meters: 279161,
    seconds: 13971,
  },
  'https://www.walkhighlands.co.uk/skye/bruachnafrithe.shtml': {
    meters: 293485,
    seconds: 14256,
  },
  'https://www.walkhighlands.co.uk/skye/innpinn.shtml': {
    meters: 315344,
    seconds: 15784,
  },
  'https://www.walkhighlands.co.uk/skye/sgurr-mhic-choinnich.shtml': {
    meters: 316529,
    seconds: 15963,
  },
  'https://www.walkhighlands.co.uk/skye/sgurraghreadaidh.shtml': {
    meters: 314427,
    seconds: 15712,
  },
  'https://www.walkhighlands.co.uk/skye/sgurralasdair.shtml': {
    meters: 316529,
    seconds: 15963,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnabanachdich.shtml': {
    meters: 314427,
    seconds: 15712,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnaneag.shtml': {
    meters: 316529,
    seconds: 15963,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnangillean.shtml': {
    meters: 293131,
    seconds: 14270,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-hope.shtml': {
    meters: 308708,
    seconds: 14770,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-klibreck.shtml': {
    meters: 278010,
    seconds: 12549,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnalligin.shtml': {
    meters: 278312,
    seconds: 12681,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinneighe.shtml': {
    meters: 267573,
    seconds: 11818,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnliathmhor.shtml': {
    meters: 262591,
    seconds: 11362,
  },
  'https://www.walkhighlands.co.uk/torridon/bideinachoiresheasgaich.shtml': {
    meters: 277463,
    seconds: 12254,
  },
  'https://www.walkhighlands.co.uk/torridon/Fionnbheinn.shtml': {
    meters: 242726,
    seconds: 10504,
  },
  'https://www.walkhighlands.co.uk/torridon/Liathach.shtml': {
    meters: 269972,
    seconds: 11991,
  },
  'https://www.walkhighlands.co.uk/torridon/maoilelunndaidh.shtml': {
    meters: 258950,
    seconds: 11216,
  },
  'https://www.walkhighlands.co.uk/torridon/Maolcheandearg.shtml': {
    meters: 268698,
    seconds: 11741,
  },
  'https://www.walkhighlands.co.uk/torridon/Moruisg.shtml': {
    meters: 253903,
    seconds: 10943,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgorrruadh.shtml': {
    meters: 262584,
    seconds: 11406,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgurrchoinnich.shtml': {
    meters: 258955,
    seconds: 11217,
  },
  'https://www.walkhighlands.co.uk/torridon/Slioch.shtml': {
    meters: 257783,
    seconds: 11213,
  },
  'https://www.walkhighlands.co.uk/ullapool/amfaochagach.shtml': {
    meters: 240765,
    seconds: 10397,
  },
  'https://www.walkhighlands.co.uk/ullapool/anteallach.shtml': {
    meters: 270303,
    seconds: 11778,
  },
  'https://www.walkhighlands.co.uk/ullapool/beinndearg.shtml': {
    meters: 257079,
    seconds: 11123,
  },
  'https://www.walkhighlands.co.uk/ullapool/benmoreassynt.shtml': {
    meters: 305433,
    seconds: 13594,
  },
  'https://www.walkhighlands.co.uk/ullapool/fannichs.shtml': {
    meters: 240765,
    seconds: 10397,
  },
  'https://www.walkhighlands.co.uk/ullapool/fisherfield-6.shtml': {
    meters: 266352,
    seconds: 11583,
  },
  'https://www.walkhighlands.co.uk/ullapool/seana-bhraigh.shtml': {
    meters: 257130,
    seconds: 11096,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrbreac.shtml': {
    meters: 254769,
    seconds: 11035,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrnanclachgeala.shtml': {
    meters: 254760,
    seconds: 11035,
  },
}

const FROM_STIRLING: {
  [name: string]: { meters: number; seconds: number }
} = {
  'https://www.walkhighlands.co.uk/angus/mayar-driesh.shtml': {
    meters: 144516,
    seconds: 7093,
  },
  'https://www.walkhighlands.co.uk/angus/mount-keen.shtml': {
    meters: 167714,
    seconds: 7639,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-achaladair.shtml': {
    meters: 96150,
    seconds: 5273,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-bhuidhe.shtml': {
    meters: 98405,
    seconds: 5162,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-dorain.shtml': {
    meters: 91412,
    seconds: 5026,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-eunaich.shtml': {
    meters: 103736,
    seconds: 5642,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-fhionnlaidh.shtml': {
    meters: 153911,
    seconds: 8609,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-mhanach.shtml': {
    meters: 84025,
    seconds: 4680,
  },
  'https://www.walkhighlands.co.uk/argyll/beinn-sgulaird.shtml': {
    meters: 149572,
    seconds: 8282,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-challum.shtml': {
    meters: 77236,
    seconds: 4317,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-cruachan.shtml': {
    meters: 109599,
    seconds: 5988,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-lui.shtml': {
    meters: 91723,
    seconds: 5029,
  },
  'https://www.walkhighlands.co.uk/argyll/ben-oss.shtml': {
    meters: 78976,
    seconds: 4430,
  },
  'https://www.walkhighlands.co.uk/argyll/stob-ghabhar.shtml': {
    meters: 96987,
    seconds: 5497,
  },
  'https://www.walkhighlands.co.uk/cairngorms/a-mharconaich.shtml': {
    meters: 135673,
    seconds: 5492,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-sgarsoch.shtml': {
    meters: 144302,
    seconds: 7684,
  },
  'https://www.walkhighlands.co.uk/cairngorms/an-socach.shtml': {
    meters: 124703,
    seconds: 6411,
  },
  'https://www.walkhighlands.co.uk/cairngorms/aonach-beag.shtml': {
    meters: 157159,
    seconds: 8227,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-bhuird.shtml': {
    meters: 150121,
    seconds: 8217,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-a-chaorainn.shtml': {
    meters: 144260,
    seconds: 7680,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-bhrotain.shtml': {
    meters: 182427,
    seconds: 7998,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-iutharn-mhor.shtml': {
    meters: 141033,
    seconds: 7439,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-mheadhoin.shtml': {
    meters: 196738,
    seconds: 8397,
  },
  'https://www.walkhighlands.co.uk/cairngorms/beinn-udlamain.shtml': {
    meters: 131861,
    seconds: 5320,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-alder.shtml': {
    meters: 157159,
    seconds: 8227,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-avon.shtml': {
    meters: 138735,
    seconds: 7234,
  },
  'https://www.walkhighlands.co.uk/cairngorms/ben-macdui.shtml': {
    meters: 144260,
    seconds: 7680,
  },
  'https://www.walkhighlands.co.uk/cairngorms/bynackmore.shtml': {
    meters: 191852,
    seconds: 8016,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairn-toul.shtml': {
    meters: 193223,
    seconds: 8076,
  },
  'https://www.walkhighlands.co.uk/cairngorms/cairnwell.shtml': {
    meters: 119220,
    seconds: 6135,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-a-mhaim.shtml': {
    meters: 144260,
    seconds: 7680,
  },
  'https://www.walkhighlands.co.uk/cairngorms/carn-na-caim.shtml': {
    meters: 138606,
    seconds: 5596,
  },
  'https://www.walkhighlands.co.uk/cairngorms/geal-charn.shtml': {
    meters: 165274,
    seconds: 7559,
  },
  'https://www.walkhighlands.co.uk/cairngorms/glas-maol.shtml': {
    meters: 121327,
    seconds: 6246,
  },
  'https://www.walkhighlands.co.uk/cairngorms/macdui-cairngorm.shtml': {
    meters: 196738,
    seconds: 8397,
  },
  'https://www.walkhighlands.co.uk/cairngorms/meall-chuaich.shtml': {
    meters: 143675,
    seconds: 5803,
  },
  'https://www.walkhighlands.co.uk/cairngorms/monadhliath.shtml': {
    meters: 161018,
    seconds: 6917,
  },
  'https://www.walkhighlands.co.uk/cairngorms/mullach-clach-a-bhlair.shtml': {
    meters: 182427,
    seconds: 7998,
  },
  'https://www.walkhighlands.co.uk/cairngorms/sgor-gaoith.shtml': {
    meters: 179458,
    seconds: 7749,
  },
  'https://www.walkhighlands.co.uk/cairngorms/tolmount.shtml': {
    meters: 130266,
    seconds: 6743,
  },
  'https://www.walkhighlands.co.uk/cairngorms/white-mounth.shtml': {
    meters: 174063,
    seconds: 9363,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonacheagach.shtml': {
    meters: 120679,
    seconds: 6390,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/aonachmor.shtml': {
    meters: 166633,
    seconds: 9449,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-a-chlachair.shtml': {
    meters: 176180,
    seconds: 7605,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-na-lap.shtml': {
    meters: 200112,
    seconds: 10151,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinn-nan-aighenan.shtml': {
    meters: 128786,
    seconds: 7641,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnabheithir.shtml': {
    meters: 131336,
    seconds: 6967,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/beinnachaorainn.shtml': {
    meters: 182122,
    seconds: 7890,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/benstarav.shtml': {
    meters: 128786,
    seconds: 7641,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/bideannambian.shtml': {
    meters: 120975,
    seconds: 6407,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/binneinmor.shtml': {
    meters: 140983,
    seconds: 7626,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivebeag.shtml': {
    meters: 118894,
    seconds: 6283,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/buachailleetivemor.shtml': {
    meters: 115371,
    seconds: 6113,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/carnmordeargarete.shtml': {
    meters: 161785,
    seconds: 8911,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/chnodearg.shtml': {
    meters: 190204,
    seconds: 8476,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creagmeagaidh.shtml': {
    meters: 169497,
    seconds: 7369,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/creise.shtml': {
    meters: 111183,
    seconds: 6010,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/easains.shtml': {
    meters: 190214,
    seconds: 8477,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gairich.shtml': {
    meters: 250201,
    seconds: 11837,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/greycorries.shtml': {
    meters: 204478,
    seconds: 9502,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/gulvain.shtml': {
    meters: 175793,
    seconds: 9438,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ladhar-bheinn.shtml': {
    meters: 223009,
    seconds: 11773,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/lochlochymunros.shtml': {
    meters: 223737,
    seconds: 10222,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/luinne-bheinn.shtml': {
    meters: 223009,
    seconds: 11773,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/ringofsteall.shtml': {
    meters: 166631,
    seconds: 9449,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgor-gaibhre.shtml': {
    meters: 200112,
    seconds: 10151,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgornaulaidh.shtml': {
    meters: 126286,
    seconds: 6668,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurr-mor.shtml': {
    meters: 233803,
    seconds: 12225,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurramhaoraich.shtml': {
    meters: 257086,
    seconds: 12380,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurreildemor.shtml': {
    meters: 141003,
    seconds: 7629,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrnaciche.shtml': {
    meters: 233803,
    seconds: 12225,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/sgurrthuilm.shtml': {
    meters: 182027,
    seconds: 9742,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/spideanmialach.shtml': {
    meters: 255148,
    seconds: 12228,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stob-ban-grey-corries.shtml': {
    meters: 205058,
    seconds: 9632,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobban.shtml': {
    meters: 163876,
    seconds: 9036,
  },
  'https://www.walkhighlands.co.uk/fortwilliam/stobcoiranalbannaich.shtml': {
    meters: 128786,
    seconds: 7641,
  },
  'https://www.walkhighlands.co.uk/kintail/Achralaig.shtml': {
    meters: 258137,
    seconds: 11632,
  },
  'https://www.walkhighlands.co.uk/kintail/Aghlasbheinn.shtml': {
    meters: 281606,
    seconds: 12896,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnfhada.shtml': {
    meters: 281606,
    seconds: 12896,
  },
  'https://www.walkhighlands.co.uk/kintail/Beinnsgritheall.shtml': {
    meters: 308428,
    seconds: 14867,
  },
  'https://www.walkhighlands.co.uk/kintail/Brothersridge.shtml': {
    meters: 266977,
    seconds: 12060,
  },
  'https://www.walkhighlands.co.uk/kintail/Cistedhubh.shtml': {
    meters: 258137,
    seconds: 11632,
  },
  'https://www.walkhighlands.co.uk/kintail/Fivesisters.shtml': {
    meters: 266960,
    seconds: 12059,
  },
  'https://www.walkhighlands.co.uk/kintail/Glenshielridge.shtml': {
    meters: 259079,
    seconds: 11684,
  },
  'https://www.walkhighlands.co.uk/kintail/sgurrnanconbhairean.shtml': {
    meters: 251489,
    seconds: 11359,
  },
  'https://www.walkhighlands.co.uk/kintail/Thesaddle.shtml': {
    meters: 271856,
    seconds: 12288,
  },
  'https://www.walkhighlands.co.uk/lochlomond/an-caisteal.shtml': {
    meters: 75540,
    seconds: 4278,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-chabhair.shtml': {
    meters: 83531,
    seconds: 4592,
  },
  'https://www.walkhighlands.co.uk/lochlomond/beinn-ime.shtml': {
    meters: 77765,
    seconds: 4031,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-lomond.shtml': {
    meters: 51656,
    seconds: 3157,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-more.shtml': {
    meters: 69018,
    seconds: 3914,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vane.shtml': {
    meters: 80520,
    seconds: 4243,
  },
  'https://www.walkhighlands.co.uk/lochlomond/ben-vorlich-lomond.shtml': {
    meters: 80520,
    seconds: 4243,
  },
  'https://www.walkhighlands.co.uk/lochlomond/cruach-ardrain.shtml': {
    meters: 55690,
    seconds: 3966,
  },
  'https://www.walkhighlands.co.uk/lochness/Benwyvis.shtml': {
    meters: 273783,
    seconds: 11272,
  },
  'https://www.walkhighlands.co.uk/lochness/carn-eige.shtml': {
    meters: 290501,
    seconds: 13165,
  },
  'https://www.walkhighlands.co.uk/lochness/Ceathreamhnan.shtml': {
    meters: 306725,
    seconds: 14604,
  },
  'https://www.walkhighlands.co.uk/lochness/mullardoch-munros.shtml': {
    meters: 289906,
    seconds: 13278,
  },
  'https://www.walkhighlands.co.uk/lochness/strathfarrar-munros.shtml': {
    meters: 280267,
    seconds: 12437,
  },
  'https://www.walkhighlands.co.uk/lochness/Tollcreagach.shtml': {
    meters: 290501,
    seconds: 13165,
  },
  'https://www.walkhighlands.co.uk/mull/ben-more-mull.shtml': {
    meters: 185911,
    seconds: 13868,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-a-ghlo.shtml': {
    meters: 108029,
    seconds: 4787,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-dearg.shtml': {
    meters: 104989,
    seconds: 4443,
  },
  'https://www.walkhighlands.co.uk/perthshire/beinn-heasgarnich.shtml': {
    meters: 71093,
    seconds: 4700,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-chonzie.shtml': {
    meters: 46021,
    seconds: 2895,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-lawers.shtml': {
    meters: 69419,
    seconds: 4265,
  },
  'https://www.walkhighlands.co.uk/perthshire/ben-vorlich.shtml': {
    meters: 50958,
    seconds: 3203,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-a-chlamain.shtml': {
    meters: 104986,
    seconds: 4443,
  },
  'https://www.walkhighlands.co.uk/perthshire/carn-mairg.shtml': {
    meters: 91050,
    seconds: 5615,
  },
  'https://www.walkhighlands.co.uk/perthshire/glas-tulaichean.shtml': {
    meters: 110520,
    seconds: 5752,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-buidhe.shtml': {
    meters: 88391,
    seconds: 5964,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-corranaich.shtml': {
    meters: 73915,
    seconds: 4686,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-garbh.shtml': {
    meters: 73173,
    seconds: 4338,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-ghaordaidh.shtml': {
    meters: 65845,
    seconds: 4179,
  },
  'https://www.walkhighlands.co.uk/perthshire/meall-nan-tarmachan.shtml': {
    meters: 69401,
    seconds: 4263,
  },
  'https://www.walkhighlands.co.uk/perthshire/schiehallion.shtml': {
    meters: 90602,
    seconds: 5462,
  },
  'https://www.walkhighlands.co.uk/perthshire/sgiath-chuil.shtml': {
    meters: 71093,
    seconds: 4700,
  },
  'https://www.walkhighlands.co.uk/perthshire/stuchd-an-lochain.shtml': {
    meters: 88460,
    seconds: 5964,
  },
  'https://www.walkhighlands.co.uk/skye/ambasteir.shtml': {
    meters: 343125,
    seconds: 15844,
  },
  'https://www.walkhighlands.co.uk/skye/blabheinn.shtml': {
    meters: 329272,
    seconds: 15587,
  },
  'https://www.walkhighlands.co.uk/skye/bruachnafrithe.shtml': {
    meters: 343596,
    seconds: 15872,
  },
  'https://www.walkhighlands.co.uk/skye/innpinn.shtml': {
    meters: 365455,
    seconds: 17400,
  },
  'https://www.walkhighlands.co.uk/skye/sgurr-mhic-choinnich.shtml': {
    meters: 366640,
    seconds: 17579,
  },
  'https://www.walkhighlands.co.uk/skye/sgurraghreadaidh.shtml': {
    meters: 364538,
    seconds: 17328,
  },
  'https://www.walkhighlands.co.uk/skye/sgurralasdair.shtml': {
    meters: 366640,
    seconds: 17579,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnabanachdich.shtml': {
    meters: 364538,
    seconds: 17328,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnaneag.shtml': {
    meters: 366640,
    seconds: 17579,
  },
  'https://www.walkhighlands.co.uk/skye/sgurrnangillean.shtml': {
    meters: 343242,
    seconds: 15886,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-hope.shtml': {
    meters: 358819,
    seconds: 16386,
  },
  'https://www.walkhighlands.co.uk/sutherland/ben-klibreck.shtml': {
    meters: 328121,
    seconds: 14165,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnalligin.shtml': {
    meters: 328423,
    seconds: 14297,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinneighe.shtml': {
    meters: 317684,
    seconds: 13434,
  },
  'https://www.walkhighlands.co.uk/torridon/Beinnliathmhor.shtml': {
    meters: 312702,
    seconds: 12978,
  },
  'https://www.walkhighlands.co.uk/torridon/bideinachoiresheasgaich.shtml': {
    meters: 327574,
    seconds: 13870,
  },
  'https://www.walkhighlands.co.uk/torridon/Fionnbheinn.shtml': {
    meters: 292837,
    seconds: 12120,
  },
  'https://www.walkhighlands.co.uk/torridon/Liathach.shtml': {
    meters: 320083,
    seconds: 13607,
  },
  'https://www.walkhighlands.co.uk/torridon/maoilelunndaidh.shtml': {
    meters: 309061,
    seconds: 12832,
  },
  'https://www.walkhighlands.co.uk/torridon/Maolcheandearg.shtml': {
    meters: 318809,
    seconds: 13357,
  },
  'https://www.walkhighlands.co.uk/torridon/Moruisg.shtml': {
    meters: 304014,
    seconds: 12559,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgorrruadh.shtml': {
    meters: 312695,
    seconds: 13022,
  },
  'https://www.walkhighlands.co.uk/torridon/Sgurrchoinnich.shtml': {
    meters: 309066,
    seconds: 12833,
  },
  'https://www.walkhighlands.co.uk/torridon/Slioch.shtml': {
    meters: 307894,
    seconds: 12829,
  },
  'https://www.walkhighlands.co.uk/ullapool/amfaochagach.shtml': {
    meters: 290876,
    seconds: 12013,
  },
  'https://www.walkhighlands.co.uk/ullapool/anteallach.shtml': {
    meters: 320414,
    seconds: 13394,
  },
  'https://www.walkhighlands.co.uk/ullapool/beinndearg.shtml': {
    meters: 307190,
    seconds: 12739,
  },
  'https://www.walkhighlands.co.uk/ullapool/benmoreassynt.shtml': {
    meters: 355544,
    seconds: 15210,
  },
  'https://www.walkhighlands.co.uk/ullapool/fannichs.shtml': {
    meters: 290876,
    seconds: 12013,
  },
  'https://www.walkhighlands.co.uk/ullapool/fisherfield-6.shtml': {
    meters: 316463,
    seconds: 13199,
  },
  'https://www.walkhighlands.co.uk/ullapool/seana-bhraigh.shtml': {
    meters: 307241,
    seconds: 12712,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrbreac.shtml': {
    meters: 304880,
    seconds: 12651,
  },
  'https://www.walkhighlands.co.uk/ullapool/sgurrnanclachgeala.shtml': {
    meters: 304871,
    seconds: 12651,
  },
}

export const DISTANCES: any = {
  Aberdeen: FROM_ABERDEEN,
  Dundee: FROM_DUNDEE,
  Glasgow: FROM_GLASGOW,
  Edinburgh: FROM_EDINBURGH,
  'Fort William': FROM_FORT_WILLIAM,
  Inverness: FROM_INVERNESS,
  Perth: FROM_PERTH,
  Stirling: FROM_STIRLING,
}
